export const i18nDefault = {
  default: {
    ACCESS_PANEL__ACCESS: "Access",
    ACCESS_PANEL__ADD_EXISTING: "Add existing users",
    ACCESS_PANEL__NAME: "Name",
    ACCESS_PANEL__ERROR: "An error has occurred.",
    ACCESS_PANEL__ERROR_2: "User {0} cannot be added as they have not completed registration",
    ACCESS_PANEL__ERROR_DESCRIPTION:
      "Please try again. To report the error, please send an email to your administrator.",
    ACCESS_PANEL__NO_DATA: "No data available",
    ACCESS_PANEL__NO_USERS: "No available users to add",
    ACCESS_PANEL__REVOKE: "Revoke",
    ACCESS_PANEL__ROLE: "Role",
    ACCESS_PANEL__SUCCESS:
      "User {0} has been granted permission. Notify the user they must sign in again to access the dataset.",
    ACCESS_PANEL__SUCCESS_REVOKE:
      "User {0} has had their permission revoked. They must sign in again for the change to take effect.",
    ACCOUNT_BUTTON__ACCOUNT: "Account",
    ACCOUNT_BUTTON__LOGIN: "Login",
    ACCOUNT_TAB__LINK: "Account",
    ACCOUNT__ACCOUNT: "Account",
    ACCOUNT__CHANGE_LANGUAGE: "Change language",
    ACCOUNT__CHANGE_PASSWORD: "Change password",
    ACCOUNT__DELETE_ACCOUNT: "Delete account",
    ACCOUNT__EMAIL: "Email",
    ACCOUNT__IMPRINT: "Imprint",
    ACCOUNT__LOGOUT: "Logout",
    ACCOUNT__NAME: "Name",
    ACCOUNT__PRIVACY_POLICY: "Privacy policy",
    ACCOUNT__SWITCH_TO_ADMIN_PORTAL: "Switch to Admin portal",
    ACCOUNT__SWITCH_TO_ATLAS: "Switch to ATLAS",
    ACCOUNT__SWITCH_TO_ETL_PORTAL: "Switch to ETL portal",
    ACCOUNT__SWITCH_TO_RESEARCHER_PORTAL: "Switch to Researcher portal",
    ACCOUNT__TERMS_OF_USE: "Terms of use",
    ACTION_SELECTOR__CLEANUP_STUDY: "Cleanup study",
    ACTION_SELECTOR__CREATE_CACHE: "Update cache",
    ACTION_SELECTOR__CREATE_DATA_MART: "Create data mart",
    ACTION_SELECTOR__CREATE_RELEASE: "Create release",
    ACTION_SELECTOR__DELETE_DATASET: "Delete dataset",
    ACTION_SELECTOR__DELETE_STUDY: "Delete study",
    ACTION_SELECTOR__DOWNLOAD_STRATEGUS_RESULTS: "Download strategus results",
    ACTION_SELECTOR__MANAGE_DASHBOARD: "Manage dashboard",
    ACTION_SELECTOR__MANAGE_RESULT_VIEWER: "Manage result viewer",
    ACTION_SELECTOR__PERMISSIONS: "Permissions",
    ACTION_SELECTOR__RESOURCES: "Resources",
    ACTION_SELECTOR__RUN_DATA_CHARACTERIZATION: "Run data characterization",
    ACTION_SELECTOR__RUN_DATA_QUALITY: "Run data quality",
    ACTION_SELECTOR__RUN_STUDY: "Run study",
    ACTION_SELECTOR__REFRESH_CACHE: "Refresh cache",
    ACTION_SELECTOR__SELECT_ACTION: "Select action",
    ACTION_SELECTOR__SETUP_SEMANTIC_SEARCH: "Setup semantic search",
    ACTION_SELECTOR__SOURCE_INFORMATION: "Source information",
    ACTION_SELECTOR__UPDATE_DATASET: "Update dataset",
    ACTION_SELECTOR__UPDATE_SCHEMA: "Update schema",
    ACTION_SELECTOR__TRANSFORM_TO_WEBAPI: "Convert to WebAPI",
    ACTION_SELECTOR__UPLOAD_STRATEGUS_RESULTS: "Upload strategus results",
    ADD_FLOW_DIALOG__ERROR_DESCRIPTION:
      "Please try again. To report the error, please send an email to your administrator.",
    ADD_STRATEGUS_STUDY_DIALOG__ANALYSIS_SPEC: "Analysis specification (JSON)",
    ADD_STRATEGUS_STUDY_DIALOG__ANALYSIS_SPEC_HELPER: "Enter a valid JSON analysis specification",
    ADD_STRATEGUS_STUDY_DIALOG__ANALYSIS_SPEC_INVALID: "Invalid JSON format for analysis specification",
    ADD_STRATEGUS_STUDY_DIALOG__CANCEL: "Cancel",
    ADD_STRATEGUS_STUDY_DIALOG__CREATE: "Create study",
    ADD_STRATEGUS_STUDY_DIALOG__ERROR_CREATE: "Failed to create study",
    ADD_STRATEGUS_STUDY_DIALOG__STUDY_INFORMATION: "Study information",
    ADD_STRATEGUS_STUDY_DIALOG__STUDY_NAME: "Study name",
    ADD_STRATEGUS_STUDY_DIALOG__STUDY_NAME_HELPER: "Enter a unique name for your study",
    ADD_STRATEGUS_STUDY_DIALOG__STUDY_NAME_INVALID:
      "Study name can only contain letters, numbers, underscores, and hyphens",
    ADD_STRATEGUS_STUDY_DIALOG__STUDY_NAME_REQUIRED: "Study name is required",
    ADD_STRATEGUS_STUDY_DIALOG__TITLE: "Add Strategus study",
    ADD_STRATEGUS_STUDY_DIALOG__TOKEN_DATASET_CODE: "Token dataset code",
    ADD_STRATEGUS_STUDY_DIALOG__TOKEN_DATASET_CODE_HELPER:
      "Enter a unique identifier that can contain alphanumeric characters and underscores only",
    ADD_STRATEGUS_STUDY_DIALOG__TOKEN_DATASET_CODE_INVALID:
      "Token dataset code must contain only alphanumeric characters and underscores (max 80 characters)",
    ADD_STRATEGUS_STUDY_DIALOG__TOKEN_DATASET_CODE_REQUIRED: "Token dataset code is required",
    ADD_STUDY_DIALOG__ADD: "Add",
    ADD_STUDY_DIALOG__ADD_DATASET: "Add dataset",
    ADD_STUDY_DIALOG__AUTO_GENERATE_RESULT_SCHEMA: "Use default result schema name",
    ADD_STUDY_DIALOG__CACHE_DATASET_CONFIGURATION: "Cache dataset configuration",
    ADD_STUDY_DIALOG__CACHE_DATASET_NAME: "Cache dataset name",
    ADD_STUDY_DIALOG__CACHE_DATASET_TYPE: "Cache dataset type",
    ADD_STUDY_DIALOG__CANCEL: "Cancel",
    ADD_STUDY_DIALOG__CDM_SCHEMA_OPTION: "CDM schema option",
    ADD_STUDY_DIALOG__CREATE_FHIR: "Create FHIR dataset",
    ADD_STUDY_DIALOG__CREATE_NEW_SCHEMA: "Create new schema",
    ADD_STUDY_DIALOG__CUSTOM_DATA_MODEL_OPTION: "Custom data model option",
    ADD_STUDY_DIALOG__DATABASES: "Databases",
    ADD_STUDY_DIALOG__DATASET_CODE_ALLOWED_VALUES: "Should only contain letters, numbers, and underscores",
    ADD_STUDY_DIALOG__DATASET_NAME: "Dataset name - Displayed on buttons and headers",
    ADD_STUDY_DIALOG__DATASET_SUMMARY: "Dataset summary",
    ADD_STUDY_DIALOG__DATA_MODEL_OPTION: "Data model option",
    ADD_STUDY_DIALOG__DESCRIPTION: "Description",
    ADD_STUDY_DIALOG__ENTER_VALID_DATASET_CODE: "Please enter a valid Token dataset code",
    ADD_STUDY_DIALOG__EXISTING_SCHEMA: "Use existing schema",
    ADD_STUDY_DIALOG__HANA_TYPE: "Type",
    ADD_STUDY_DIALOG__INFO_CONFIG: "Dataset info configuration",
    ADD_STUDY_DIALOG__INVALID_SCHEMA_NAME: "Invalid schema name",
    ADD_STUDY_DIALOG__MANAGEMENT_MODE: "Management mode",
    ADD_STUDY_DIALOG__MANAGEMENT_MODE_WEBAPI: "WebAPI-managed (OMOP only, no cache dataset)",
    ADD_STUDY_DIALOG__MANAGEMENT_MODE_SOURCE: "Source (with cache dataset)",
    ADD_STUDY_DIALOG__NO_AVAILABLE_SCHEMA: "No available schemas found. Please select another schema option.",
    ADD_STUDY_DIALOG__PA_CONFIG: "PA config",
    ADD_STUDY_DIALOG__REQUIRED: "This is required",
    ADD_STUDY_DIALOG__RESULT_SCHEMA_NAME: "Result schema name",
    ADD_STUDY_DIALOG__SCHEMA_NAME: "Schema name",
    ADD_STUDY_DIALOG__TOKEN_DATASET_CODE: "Token dataset code",
    ADD_STUDY_DIALOG__TYPE: "Type",
    ADD_STUDY_DIALOG__USE_SAME_SCHEMA: "Use same CDM schema for vocab schema",
    ADD_STUDY_DIALOG__VOCAB_SCHEMA_NAME: "Vocab schema name",
    ADD_STUDY_DIALOG__DATASET_CREATED_TITLE: "Dataset created",
    ADD_STUDY_DIALOG__DATASET_CREATED_DESCRIPTION: "Dataset {0} has been created successfully.",
    ADD_TAG_DIALOG__ADD_TAG: "Add tag",
    ADD_TAG_DIALOG__CANCEL: "Cancel",
    ADD_TAG_DIALOG__SAVE: "Save",
    ADD_TAG_DIALOG__SUCCESS: "Tag config added successfully.",
    ADD_TAG_DIALOG__TAG_NAME: "Tag name",
    ADD_USER_DIALOG__ADD: "Add",
    ADD_USER_DIALOG__ADD_USER: "Add user",
    ADD_USER_DIALOG__CANCEL: "Cancel",
    ADD_USER_DIALOG__ERROR: "An error has occurred.",
    ADD_USER_DIALOG__ERROR_DESCRIPTION:
      "Please try again. To report the error, please send an email to your administrator.",
    ADD_USER_DIALOG__GENERATE: "Generate",
    ADD_USER_DIALOG__HIDE_PASSWORD: "Hide password",
    ADD_USER_DIALOG__PASSWORD: "Password",
    ADD_USER_DIALOG__REQUIRED: "This is required",
    ADD_USER_DIALOG__SHOW_PASSWORD: "Show password",
    ADD_USER_DIALOG__SUCCESS: "User added successfully",
    ADD_USER_DIALOG__USERNAME: "Username",
    ADD_USER_DIALOG__USERNAME_HELPER: "Username should only contain letters, numbers, or underscore.",
    AI_MODELS__ERROR: "Error loading page. Please check that the plugin is installed",
    ANALYSIS_DIALOG__CANCEL: "Cancel",
    ANALYSIS_DIALOG__COMMENT: "Comment",
    ANALYSIS_DIALOG__DATA_CHARACTERIZATION: "Data characterization",
    ANALYSIS_DIALOG__DATA_QUALITY: "Data quality",
    ANALYSIS_DIALOG__FORM_TITLE: "Dataset analysis configuration",
    ANALYSIS_DIALOG__RESULTS_SCHEMA_NAME: "Preferred schema name (optional)",
    ANALYSIS_DIALOG__RUN: "Run analysis",
    ANALYSIS_DIALOG__RUN_SUCCESS: "Successfully generated {0} job for {1}",
    ANALYSIS_DIALOG__TITLE: "Run {0} for dataset: {1}",
    ANALYSIS_DIALOG__UNTITLED_DATASET: "Untitled dataset",
    ATTRIBUTE_TABLE__ADD_ATTRIBUTE: "Add attribute",
    ATTRIBUTE_TABLE__ATTRIBUTE_ID: "Attribute ID",
    ATTRIBUTE_TABLE__ATTRIBUTE_NAME: "Attribute name",
    ATTRIBUTE_TABLE__CATEGORY: "Category",
    ATTRIBUTE_TABLE__DATATYPE: "Datatype",
    ATTRIBUTE_TABLE__DELETE: "Delete",
    ATTRIBUTE_TABLE__EDIT: "Edit",
    ATTRIBUTE_TABLE__LOADER: "Loading attribute configs",
    ATTRIBUTE_TABLE__METADATA: "Metadata",
    AZURE_AD__SAVE: "Save",
    AZURE_AD__TEXT_FIELD_1_LABEL: "Azure group ID for tenant viewer",
    AZURE_AD__TEXT_FIELD_2_LABEL: "Azure group ID for system admin",
    AZURE_AD__TEXT_FIELD_3_LABEL: "Azure group ID for user admin",
    AZURE_AD__TITLE: "Azure AD integration",
    BAR_CHART__NO_DATA: "Results not available",
    BIG_QUERY_FORM__DATASET: "Dataset",
    BIG_QUERY_FORM__DATASET_HELPER: "Optional — leave blank to connect to the whole project",
    BIG_QUERY_FORM__PROJECT: "Project",
    SNOWFLAKE_FORM__ACCOUNT: "Account identifier",
    SNOWFLAKE_FORM__DATABASE: "Database",
    SNOWFLAKE_FORM__WAREHOUSE: "Warehouse",
    SNOWFLAKE_FORM__SCHEMA: "Schema",
    SNOWFLAKE_FORM__ROLE: "Role",
    SNOWFLAKE_FORM__PASSPHRASE: "Private key passphrase (optional)",
    SNOWFLAKE_FORM__PRIVATE_KEY: "Private key (PEM)",
    BOX_PLOT_CHART__NO_DATA: "Results not available",
    CDM_DOWNLOAD_DIALOG__ERROR_DOWNLOAD:
      "Error occurred while downloading patient data. To report the error, please send an email to your administrator",
    CDM_DOWNLOAD_DIALOG__ERROR_ZIP:
      "Error occurred while retrieving ZIP from MRI. To report the error, please send an email to your administrator",
    CDM_SUMMARY__NO_DATA: "Results not available",
    CDM_SUMMARY__NUMBER_OF_PERSONS: "Number of persons",
    CDM_SUMMARY__SOURCE_NAME: "Source name",
    CDM_SUMMARY__TITLE: "CDM Summary",
    CHANGE_LANGUAGE_DIALOG__BUTTON_CANCEL: "Cancel",
    CHANGE_LANGUAGE_DIALOG__BUTTON_UPDATE: "Update",
    CHANGE_LANGUAGE_DIALOG__DIALOG_TITLE: "Change language",
    CHANGE_LANGUAGE_DIALOG__LANGUAGE: "Language",
    CHANGE_LANGUAGE_DIALOG__LANGUAGE_UPDATED: "Language updated",
    CHANGE_LANGUAGE_DIALOG__LANGUAGE_UPDATED_ERROR_DESCRIPTION:
      "Please try again. To report the error, please send an email to your administrator.",
    CHANGE_LANGUAGE_DIALOG__LANGUAGE_UPDATED_ERROR_MESSAGE: "An error has occurred.",
    CHANGE_LANGUAGE_DIALOG__LANGUAGE_UPDATED_SUCCESS: "Language updated successfully",
    CHANGE_LANGUAGE_DIALOG__NO_CHANGES: "No language changes were made.",
    CHANGE_LANGUAGE_DIALOG__TRY_AGAIN: "Try again",
    CHANGE_LANGUAGE_DIALOG__UPDATE_FAILED: "Unable to update language. Please try again.",
    CHANGE_MY_PASSWORD_DIALOG__BUTTON_CANCEL: "Cancel",
    CHANGE_MY_PASSWORD_DIALOG__BUTTON_GENERATE: "Generate",
    CHANGE_MY_PASSWORD_DIALOG__BUTTON_UPDATE: "Change",
    CHANGE_MY_PASSWORD_DIALOG__DIALOG_TEXT_FIELD_LABEL_1: "Old password",
    CHANGE_MY_PASSWORD_DIALOG__DIALOG_TEXT_FIELD_LABEL_2: "New password",
    CHANGE_MY_PASSWORD_DIALOG__DIALOG_TITLE: "Change password",
    CHANGE_MY_PASSWORD_DIALOG__DIALOG_TOOLTIP_TITLE_1: "Hide password",
    CHANGE_MY_PASSWORD_DIALOG__DIALOG_TOOLTIP_TITLE_2: "Show password",
    CHANGE_MY_PASSWORD_DIALOG__PASSWORD_UPDATED: "Your password has been updated successfully",
    CHANGE_MY_PASSWORD_DIALOG__PASSWORD_UPDATED_ERROR_DESCRIPTION: "Unable to update password. Please try again.",
    CHANGE_MY_PASSWORD_DIALOG__PASSWORD_UPDATED_ERROR_MESSAGE: "Password update failed.",
    CHANGE_USER_PASSWORD_DIALOG__CANCEL: "Cancel",
    CHANGE_USER_PASSWORD_DIALOG__CHANGE_USER_PASSWORD: "Change user password",
    CHANGE_USER_PASSWORD_DIALOG__ERROR: "Password update failed.",
    CHANGE_USER_PASSWORD_DIALOG__ERROR_DESCRIPTION: "Unable to update password. Please try again.",
    CHANGE_USER_PASSWORD_DIALOG__GENERATE: "Generate",
    CHANGE_USER_PASSWORD_DIALOG__HIDE_PASSWORD: "Hide password",
    CHANGE_USER_PASSWORD_DIALOG__PASSWORD: "Password",
    CHANGE_USER_PASSWORD_DIALOG__PASSWORD_UPDATED: "{0} password has been updated successfully",
    CHANGE_USER_PASSWORD_DIALOG__SHOW_PASSWORD: "Show password",
    CHANGE_USER_PASSWORD_DIALOG__UPDATE: "Change",
    CLEANUP_STRATEGUS_STUDY_DIALOG__CANCEL: "Cancel",
    CLEANUP_STRATEGUS_STUDY_DIALOG__CLEANUP_STUDY: "Cleanup study",
    CLEANUP_STRATEGUS_STUDY_DIALOG__CONFIRM_MESSAGE:
      'Are you sure you want to cleanup the results of study "{0}"? This action cannot be undone.',
    CLEANUP_STRATEGUS_STUDY_DIALOG__ERROR_CLEANUP_STUDY: 'Failed to cleanup study "{0}"',
    CLEANUP_STRATEGUS_STUDY_DIALOG__SUCCESS_STUDY_CLEANUP: 'Study "{0}" cleanup completed successfully',
    CLEANUP_STRATEGUS_STUDY_DIALOG__TITLE: "Cleanup Strategus study",
    CODE_NAME_SELECT__ENTER_NEW_NAME: "Enter new name",
    CODE_NAME_SELECT__NAME: "Name",
    CODE_NAME_SELECT__NEW: "+ New",
    CODE_NAME_SELECT__NEW_NAME: "New name",
    COHORT_DEFINITION_LIST__CREATION_TIMESTAMP: "Created",
    COHORT_DEFINITION_LIST__DESCRIPTION: "Description",
    COHORT_DEFINITION_LIST__ERROR_OCCURRED: "An error has occurred.",
    COHORT_DEFINITION_LIST__ID: "ID",
    COHORT_DEFINITION_LIST__JOBS: "Jobs",
    COHORT_DEFINITION_LIST__NAME: "Name",
    COHORT_DEFINITION_LIST__PATIENT_COUNT: "Patient count",
    COHORT_DEFINITION_LIST__TRY_AGAIN:
      "Please try again. To report the error, please send an email to your administrator.",
    COHORT_DELETE_DIALOG__ARE_YOU_SURE: "Are you sure you want to delete the following cohort",
    COHORT_DELETE_DIALOG__CANCEL: "Cancel",
    COHORT_DELETE_DIALOG__CONFIRM: "Yes, delete",
    COHORT_DELETE_DIALOG__DELETE_COHORT: "Delete cohort",
    COHORT_DELETE_DIALOG__DELETE_SUCCESSFUL: "Cohort deleted successfully.",
    COHORT_DELETE_DIALOG__DESCRIPTION: "Description",
    COHORT_DELETE_DIALOG__ERROR_OCCURRED: "An error has occurred.",
    COHORT_DELETE_DIALOG__ERROR_OCCURRED_DESCRIPTION:
      "Please try again. To report the error, please send an email to your administrator.",
    COHORT_DELETE_DIALOG__NAME: "Name",
    COHORT_FILTER__COHORT: "Cohort",
    COHORT_FILTER__LOADING: "Loading cohort definitions...",
    COHORT_FILTER__NO_COHORTS: "No cohorts found in study",
    COHORT_FILTER__SELECT_COHORT_FILTER: "Select cohort filter",
    COHORT_HIERARCHY__ERROR: "Please try again.",
    COHORT_PLUGIN__COHORT_MANAGEMENT: "Cohort management",
    COHORT_SURVIVAL__ERROR_OCCURRED: "An error has occurred.",
    COHORT_SURVIVAL__GRAPH_LOADING: "Graph is loading...",
    COHORT_SURVIVAL__RUN_SURVIVAL_ANALYSIS: "Run survival analysis",
    COHORT_SURVIVAL__SELECT_COMPETING_OUTCOME_COHORT: "Competing outcome cohort",
    COHORT_SURVIVAL__SELECT_OUTCOME_COHORT: "Outcome cohort",
    COHORT_SURVIVAL__SELECT_TARGET_COHORT: "Target cohort",
    COHORT_SURVIVAL__TITLE: "Kaplan-Meier survival analysis",
    COHORT_SURVIVAL__TRY_AGAIN: "Please try again. To report the error, please send an email to your administrator.",
    COHORT__MISSING_USER_ID: "Missing User Id and Dataset Id",
    CONCEPT_SETS__ADD_CONCEPT_SET: "Add concept set",
    CONCEPT_SETS__AUTHOR: "Author",
    CONCEPT_SETS__CREATED: "Created",
    CONCEPT_SETS__ERROR: "An error has occurred",
    CONCEPT_SETS__ERROR_DESCRIPTION: "Please try again.",
    CONCEPT_SETS__ID: "ID",
    CONCEPT_SETS__Name: "Name",
    CONCEPT_SETS__SEARCH: "Concept search",
    CONCEPT_SETS__SHARED: "Shared",
    CONCEPT_SETS__UPDATED: "Updated",
    CONCEPT_SET_DELETE_DIALOG__ARE_YOU_SURE: "Are you sure you want to delete the following concept set",
    CONCEPT_SET_DELETE_DIALOG__CANCEL: "Cancel",
    CONCEPT_SET_DELETE_DIALOG__CONFIRM: "Yes, delete",
    CONCEPT_SET_DELETE_DIALOG__DELETE_CONCEPT_SET: "Delete concept set",
    CONCEPT_SET_DELETE_DIALOG__DELETE_SUCCESSFUL: "Concept set deleted successfully.",
    CONCEPT_SET_DELETE_DIALOG__ERROR_FORBIDDEN: "You do not have permission to delete this concept set.",
    CONCEPT_SET_DELETE_DIALOG__ERROR_IN_USE: "Cannot delete concept set. It is currently in use.",
    CONCEPT_SET_DELETE_DIALOG__ERROR_IN_USE_BOOKMARKS: "D2E cohort definitions",
    CONCEPT_SET_DELETE_DIALOG__ERROR_IN_USE_COHORTS: "Atlas cohort definitions",
    CONCEPT_SET_DELETE_DIALOG__ERROR_NOT_FOUND: "The concept set was not found. It may have already been deleted.",
    CONCEPT_SET_DELETE_DIALOG__ERROR_OCCURRED: "An error has occurred.",
    CONCEPT_SET_DELETE_DIALOG__ERROR_OCCURRED_DESCRIPTION:
      "Please try again. To report the error, please send an email to your administrator.",
    CONCEPT_SET_DELETE_DIALOG__ERROR_SERVER: "A server error occurred while deleting the concept set.",
    COPY_STUDY_DIALOG__CACHE_DATASET_TYPE: "Cache dataset type",
    COPY_STUDY_DIALOG__CANCEL: "Cancel",
    COPY_STUDY_DIALOG__COHORT_FILTER: "Cohort filter",
    COPY_STUDY_DIALOG__COHORT_NOT_CHOSEN: "Cohort filter is checked, but no cohort was chosen!",
    COPY_STUDY_DIALOG__CREATE: "Create",
    COPY_STUDY_DIALOG__CREATE_DATA_MART: "Create data mart - {0}",
    COPY_STUDY_DIALOG__DATE_FILTER: "Date filter",
    COPY_STUDY_DIALOG__DEFINITION_FETCH_ERROR:
      "Error loading Cohort Definitions, Please try refreshing page to load again",
    COPY_STUDY_DIALOG__METADATA_FETCH_ERROR: "Error Study Schema Metadata, Please try refreshing page to load again",
    COPY_STUDY_DIALOG__NEW_DATASET_NAME: "New dataset name",
    COPY_STUDY_DIALOG__NO_TABLE_CHOSEN: "Table Filter is checked, but no table was chosen!",
    COPY_STUDY_DIALOG__PA_CONFIG_REQUIRED: "PA config ID is required!",
    COPY_STUDY_DIALOG__TABLE_FILTER: "Table filter",
    COPY_STUDY_DIALOG__DATAMART_CREATED_TITLE: "Datamart created",
    COPY_STUDY_DIALOG__DATAMART_CREATED_DESCRIPTION: "Datamart {0} has been created successfully.",
    CREATE_CACHE_DIALOG__CANCEL: "Cancel",
    CREATE_CACHE_DIALOG__FETCH_SOURCE_ERROR: "Failed to fetch source dataset information.",
    CREATE_CACHE_DIALOG__MISSING_DATASET_ID: "Missing dataset identifier. Please refresh and try again.",
    CREATE_CACHE_DIALOG__MISSING_FHIR_INFO:
      "Missing required information for FHIR cache update. Please refresh and try again.",
    CREATE_CACHE_DIALOG__RUN: "Run cache update",
    CREATE_CACHE_DIALOG__RUN_SUCCESS: "Successfully triggered cache update for dataset: {0}",
    CREATE_CACHE_DIALOG__TITLE: "Update cache for dataset: {0}",
    CREATE_CACHE_DIALOG__FLOW_TRIGGERED_TITLE: "Create cache flow triggered",
    CREATE_CACHE_DIALOG__FLOW_TRIGGERED_DESCRIPTION: "The create cache flow for {0} has been triggered successfully.",
    CREATE_RELEASE_DIALOG__CANCEL: "Cancel",
    CREATE_RELEASE_DIALOG__CREATE: "Create",
    CREATE_RELEASE_DIALOG__CREATE_RELEASE: "Create release - {0}",
    CREATE_RELEASE_DIALOG__ERROR: "Schema for dataset {0} failed to update",
    CREATE_RELEASE_DIALOG__RELEASE_NAME: "Release name",
    CREATE_SEMANTIC_SEARCH_DIALOG__CANCEL: "Cancel",
    CREATE_SEMANTIC_SEARCH_DIALOG__RUN: "Setup semantic search",
    CREATE_SEMANTIC_SEARCH_DIALOG__RUN_ERROR: "Unable to start semantic search: dataset is missing.",
    CREATE_SEMANTIC_SEARCH_DIALOG__RUN_SUCCESS: "Successfully generated the semantic search creation for dataset: {0}",
    CREATE_SEMANTIC_SEARCH_DIALOG__TITLE: "Setup semantic search for dataset: {0}",
    CSV_READER__CLICK_MESSAGE: "Click here to choose a file, or drop a file",
    CSV_READER__SUPPORTED_FILE_TYPES: "Supported file types: CSV",
    CSV_READER__UNSUPPORTED_FILE_TYPE: "Unsupported file type",
    DASHBOARD__ERROR_MESSAGE: "Error occurred when fetching data characterization dashboard data",
    DASHBOARD__LOADER: "Loading dashboard reports",
    DASHBOARD__PIE_CHART_TITLE: "Gender",
    DATASET_CARD__CHART_NAME: "Entity distribution",
    DATASET_CARD__DATA_MODEL: "Data model",
    DATASET_CARD__DATE: "Date",
    DATASET_CARD__NO_DATASET_SUMMARY: "No dataset summary available",
    DATASET_CARD__PATIENT_COUNT: "Total subjects",
    DATASET_CARD__VERSION: "Version",
    DATASET_DELETE_RESOURCE_DIALOG__CONFIRM: "Are you sure you want to delete the following file",
    DATASET_DELETE_RESOURCE_DIALOG__DELETE: "Delete",
    DATASET_DELETE_RESOURCE_DIALOG__DELETE_FILE: "Delete file",
    DATASET_DELETE_RESOURCE_DIALOG__ERROR: "An error has occurred.",
    DATASET_DELETE_RESOURCE_DIALOG__ERROR_DESCRIPTION:
      "Please try again. To report the error, please send an email to your administrator.",
    DATASET_FILTERS__AGE_RANGE: "Age range",
    DATASET_FILTERS__DOMAIN_REQUIREMENT: "Domain requirement",
    DATASET_FILTERS__ENTER_RANGE: "Enter range:",
    DATASET_FILTERS__MIN_CUMULATIVE_OBSERVATION: "Minimum cumulative observation",
    DATASET_FILTERS__OBSERVATION_YEAR_RANGE: "Observation year range",
    DATASET_FILTERS__RANGE_REQUIREMENT: "Range requirement",
    DATASET_FILTERS__SELECT_APPLICABLE_FILTERS: "Select applicable filters",
    DATASET_FILTERS__SELECT_REQUIREMENT: "Select requirement",
    DATASET_FILTERS__YEAR_RANGE: "Year range:",
    DATASET_RESOURCES_DIALOG__ACTION: "Action",
    DATASET_RESOURCES_DIALOG__ADD_FILE: "Add file",
    DATASET_RESOURCES_DIALOG__CANCEL: "Cancel",
    DATASET_RESOURCES_DIALOG__DELETE: "Delete",
    DATASET_RESOURCES_DIALOG__DONE: "Done",
    DATASET_RESOURCES_DIALOG__DOWNLOAD: "Download",
    DATASET_RESOURCES_DIALOG__ERROR: "An error has occurred",
    DATASET_RESOURCES_DIALOG__FILE: "File",
    DATASET_RESOURCES_DIALOG__FILENAME: "Filename",
    DATASET_RESOURCES_DIALOG__NO_FILE_AVAILABLE: "No file available",
    DATASET_RESOURCES_DIALOG__SIZE: "Size",
    DATASET_RESOURCES_DIALOG__SUCCESS: "File deleted successfully.",
    DATASET_RESOURCES_DIALOG__TITLE_1: "Resources",
    DATASET_RESOURCES_DIALOG__TITLE_2: "Untitled",
    DATASET_RESOURCE_UPLOAD_CONFIRM_DIALOG__ADD: "Add",
    DATASET_RESOURCE_UPLOAD_CONFIRM_DIALOG__ADD_FILE: "Add file",
    DATASET_RESOURCE_UPLOAD_CONFIRM_DIALOG__CANCEL: "Cancel",
    DATASET_RESOURCE_UPLOAD_CONFIRM_DIALOG__ERROR: "An error has occurred.",
    DATASET_RESOURCE_UPLOAD_CONFIRM_DIALOG__ERROR_DESCRIPTION:
      "Please try again. To report the error, please send an email to your administrator.",
    DATASET_RESOURCE_UPLOAD_CONFIRM_DIALOG__FILE: "File",
    DATASET_RESOURCE_UPLOAD_CONFIRM_DIALOG__UNTITLED: "Untitled",
    DATASET_SELECTOR__SELECT_STUDY: "Select study",
    DATA_CHARACTERIZATION_REPORTS__REPORT_SELECTOR_LABEL: "Select data characterization report",
    DATA_DENSITY_RECORDS_PER_PERSON_CHART__NO_DATA: "Results not available",
    DATA_DENSITY_RECORDS_PER_PERSON_CHART__TITLE: "Records per person",
    DATA_DENSITY_RECORDS_PER_PERSON_CHART__X_AXIS_NAME: "Year",
    DATA_DENSITY_RECORDS_PER_PERSON_CHART__Y_AXIS_NAME: "Records per person",
    DATA_DENSITY_TOTAL_RECORDS_CHART__NO_DATA: "Results not available",
    DATA_DENSITY_TOTAL_RECORDS_CHART__TITLE: "Total rows",
    DATA_DENSITY_TOTAL_RECORDS_CHART__X_AXIS_NAME: "Year",
    DATA_DENSITY_TOTAL_RECORDS_CHART__Y_AXIS_NAME: "# of Records",
    DATA_DENSITY__BOX_PLOT_TITLE: "Concepts per person",
    DATA_DENSITY__BOX_PLOT_X_AXIS_NAME: "Concept type",
    DATA_DENSITY__BOX_PLOT_Y_AXIS_NAME: "Concepts per person",
    DATA_DENSITY__ERROR_MESSAGE: "Error occurred when fetching data characterization data density data",
    DATA_DENSITY__LOADER: "Loading data density reports",
    DATA_QUALITY_DIALOG__LATEST_JOB: "Latest data quality job is",
    DATA_QUALITY_DIALOG__LATEST_JOB_CANCELLED: "Latest job cancelled",
    DATA_QUALITY_DIALOG__LATEST_JOB_FAILED: "Latest job failed",
    DATA_QUALITY_DIALOG__LOAD_LATEST_RUN: "Loading data quality latest flow run",
    DATA_QUALITY_DIALOG__NO_JOB_FOUND:
      "No data quality job found for cohort, click Run data quality button to generate data quality results",
    DATA_QUALITY_DIALOG__RESULTS: "Data quality results for cohort",
    DATA_QUALITY_DIALOG__RUN_DATA_QUALITY: "Run data quality",
    DATA_QUALITY_HISTORY__DOMAIN_CONTINUITY: "Domain continuity",
    DATA_QUALITY_HISTORY__ERROR:
      "Failed to retrieve data for charts. To report the error, please send an email to your administrator.",
    DB__ADD_DATABASE: "Add database",
    DB__DATABASES: "Databases",
    DB__DELETE: "Delete",
    DB__DIALECT: "Dialect",
    DB__EDIT: "Edit",
    DB__HOST: "Host",
    DB__ID: "ID",
    DB__LOADER: "Loading databases",
    DB__NAME: "Name",
    DB__NO_DATA: "No data available",
    DB__PORT: "Port",
    DEATH_PREVALENCE_BY_MONTH_CHART__NO_DATA: "Results not available",
    DEATH_PREVALENCE_BY_MONTH_CHART__TITLE: "Death prevalence by month",
    DEATH_PREVALENCE_BY_MONTH_CHART__TOOLTIP_FORMAT: "Date: {b}<br />Prevalence per 1000 people: {c}",
    DEATH_PREVALENCE_BY_MONTH_CHART__X_AXIS_NAME: "Date",
    DEATH_PREVALENCE_BY_MONTH_CHART__Y_AXIS_FORMAT: "{value}",
    DEATH_PREVALENCE_BY_MONTH_CHART__Y_AXIS_NAME: "Prevalence per 1000 people",
    DEATH__BOX_PLOT_CHART_TITLE: "Age at death",
    DEATH__BOX_PLOT_CHART_X_AXIS_NAME: "Gender",
    DEATH__BOX_PLOT_CHART_Y_AXIS_NAME: "Age at first occurrence",
    DEATH__ERROR_MESSAGE: "Error occurred when fetching data characterization death data",
    DEATH__LOADER: "Loading death reports",
    DEATH__PIE_CHART_TITLE: "Death by type",
    DEATH__PREVALENCE_TITLE: "Death prevalence",
    DELETE_ACCOUNT_DIALOG__CANCEL: "Cancel",
    DELETE_ACCOUNT_DIALOG__CONFIRM: "Are you sure you want to delete your account?",
    DELETE_ACCOUNT_DIALOG__DELETE: "Yes, delete",
    DELETE_ACCOUNT_DIALOG__TITLE: "Delete account",
    DELETE_ACCOUNT_DIALOG__WARNING: "You can't undo this action",
    DELETE_ATTRIBUTE_DIALOG__ATTRIBUTES: "Attribute",
    DELETE_ATTRIBUTE_DIALOG__CANCEL: "Cancel",
    DELETE_ATTRIBUTE_DIALOG__CONFIRMATION: "Are you sure you want to delete the following",
    DELETE_ATTRIBUTE_DIALOG__DELETE: "Delete",
    DELETE_ATTRIBUTE_DIALOG__DELETE_ATTRIBUTE: "Delete attribute",
    DELETE_ATTRIBUTE_DIALOG__SUCCESS: "Attribute config deleted successfully.",
    DELETE_DB_DIALOG__CANCEL: "Cancel",
    DELETE_DB_DIALOG__CONFIRMATION: "Are you sure you want to delete the following",
    DELETE_DB_DIALOG__DELETE: "Delete",
    DELETE_DB_DIALOG__DELETE_DATABASE: "Delete database",
    DELETE_DB_DIALOG__DELETE_SUCCESS: "Database deleted successfully",
    DELETE_DB_DIALOG___DATABASE: "Database",
    DELETE_FLOW_DIALOG__CANCEL: "Cancel",
    DELETE_FLOW_DIALOG__CONFIRM_1: "Are you sure you want to permanently delete the following",
    DELETE_FLOW_DIALOG__CONFIRM_2: "flow",
    DELETE_FLOW_DIALOG__CONFIRM_3: "This action cannot be undone. Deleted data cannot be recovered.",
    DELETE_FLOW_DIALOG__CONFIRM_4: "Type the flow name to confirm.",
    DELETE_FLOW_DIALOG__CONFIRM_DELETION: "Confirm deletion",
    DELETE_FLOW_DIALOG__DELETE: "Delete flow",
    DELETE_FLOW_DIALOG__ENTER_EXACT_FLOW_NAME: "Enter the exact flow name",
    DELETE_FLOW_DIALOG__ENTER_FLOW_NAME: "Enter flow name",
    DELETE_FLOW_DIALOG__ERROR: "Flow {0} failed to delete",
    DELETE_STUDY_DIALOG__CANCEL: "Cancel",
    DELETE_STUDY_DIALOG__CONFIRM: "Are you sure you want to delete this dataset",
    DELETE_STUDY_DIALOG__CONFIRM_INSTRUCTION:
      "This action cannot be undone. Please enter the dataset name to confirm deletion.",
    DELETE_STUDY_DIALOG__DELETE_DATASET: "Delete dataset",
    DELETE_STUDY_DIALOG__ENTER_DATASET_NAME: "Enter dataset name to confirm",
    DELETE_STUDY_DIALOG__ENTER_EXACT_DATASET_NAME: "Please enter the exact dataset name",
    DELETE_STUDY_DIALOG__ERROR: "Study {0} failed to delete",
    DELETE_STUDY_DIALOG__SUCCESS: "Dataset deleted successfully",
    DELETE_STUDY_DIALOG__WARNING_CHILDREN:
      "Warning: This dataset has {0} cache dataset{1}. Deleting this dataset will also delete all its cache datasets.",
    DELETE_STUDY_DIALOG__YES_DELETE: "Yes, delete",
    DELETE_STRATEGUS_STUDY_DIALOG__CANCEL: "Cancel",
    DELETE_STRATEGUS_STUDY_DIALOG__CONFIRM: "Are you sure you want to delete this study",
    DELETE_STRATEGUS_STUDY_DIALOG__CONFIRM_INSTRUCTION:
      "This action cannot be undone. Please enter the study ID to confirm deletion.",
    DELETE_STRATEGUS_STUDY_DIALOG__ENTER_STUDY_ID: "Enter study ID to confirm",
    DELETE_STRATEGUS_STUDY_DIALOG__ENTER_EXACT_STUDY_ID: "Please enter the exact study ID",
    DELETE_STRATEGUS_STUDY_DIALOG__ERROR: 'Failed to delete study "{0}"',
    DELETE_STRATEGUS_STUDY_DIALOG__TITLE: "Delete Strategus study",
    DELETE_STRATEGUS_STUDY_DIALOG__YES_DELETE: "Yes, delete",
    DELETE_TAG_DIALOG__CANCEL: "Cancel",
    DELETE_TAG_DIALOG__CONFIRM_1: "Are you sure you want to delete the following",
    DELETE_TAG_DIALOG__CONFIRM_2: "Tag",
    DELETE_TAG_DIALOG__DELETE: "Delete",
    DELETE_TAG_DIALOG__DELETE_TAG: "Delete tag",
    DELETE_TAG_DIALOG__SUCCESS: "Tag config deleted successfully.",
    DELETE_USER_DIALOG__CANCEL: "Cancel",
    DELETE_USER_DIALOG__CONFIRM: "Are you sure you want to delete this account",
    DELETE_USER_DIALOG__DELETE_USER: "Delete user",
    DELETE_USER_DIALOG__DESCRIPTION:
      "Please try again. To report the error, please send an email to your administrator.",
    DELETE_USER_DIALOG__ERROR: "An error has occurred.",
    DELETE_USER_DIALOG__SUCCESS: "User deleted successfully",
    DELETE_USER_DIALOG__YES: "Yes, delete",
    DEMO_SETUP__DESCRIPTION: "Please execute the following step to setup the demo dataset:",
    DEMO_SETUP__RUN: "Run",
    DEMO_SETUP__SETUP_DEMO_DESCRIPTION: "Initialize system",
    DEMO_SETUP__SETUP_DEMO_TITLE: "Demo setup",
    DEMO_SETUP__SETUP_PHENOTYPE_DESCRIPTION: "Run standalone phenotype flow",
    MIGRATE_USER_ARTIFACTS__TITLE: "Migrate user artifacts",
    MIGRATE_USER_ARTIFACTS__DESCRIPTION: "Migrate user artifacts to WebAPI",
    MIGRATE_USER_ARTIFACTS__ITEM_NAME: "Migrate Atlas cohort definitions",
    MIGRATE_USER_ARTIFACTS__RUN: "Migrate",
    MIGRATE_USER_ARTIFACTS__NO_ITEMS: "No Atlas cohort definitions user artifacts to migrate",
    MIGRATE_USER_ARTIFACTS__SUCCESS: "Successfully migrated {0}/{1} Atlas cohort definitions",
    MIGRATE_USER_ARTIFACTS__ERROR: "Migration failed.",
    DISCLAIMER_DIALOG_DIALOG__DESCRIPTION:
      "Please try again. To report the error, please send an email to your administrator.",
    DISCLAIMER_DIALOG_DIALOG__ERROR: "An error has occurred.",
    DISCLAIMER_DIALOG__ACCEPT: "Accept",
    DISCLAIMER_DIALOG__TITLE: "Disclaimer",
    DISCLAIMER__TITLE: "Disclaimer",
    DOMAIN_CONTINUITY_CHART__NO_DATA: "Results not available",
    DOMAIN_CONTINUITY_CHART__X_AXIS_NAME: "CDM Release Date",
    DOMAIN_CONTINUITY_CHART__Y_AXIS_NAME: "No. of records",
    DOWNLOAD_DATA_BUTTONS__CATEGORY: "CATEGORY",
    DOWNLOAD_DATA_BUTTONS__CONTEXT: "CONTEXT",
    DOWNLOAD_DATA_BUTTONS__DESCRIPTION: "DESCRIPTION",
    DOWNLOAD_DATA_BUTTONS__DOWNLOAD_CSV: "Download CSV",
    DOWNLOAD_DATA_BUTTONS__DOWNLOAD_JSON: "Download JSON",
    DOWNLOAD_DATA_BUTTONS__LEVEL: "LEVEL",
    DOWNLOAD_DATA_BUTTONS__NOTES: "NOTES",
    DOWNLOAD_DATA_BUTTONS__NUMVIOLATEDROWS: "NUMVIOLATEDROWS",
    DOWNLOAD_DATA_BUTTONS__STATUS: "STATUS",
    DOWNLOAD_DATA_BUTTONS__SUBCATEGORY: "SUBCATEGORY",
    DOWNLOAD_DATA_BUTTONS__TABLE: "TABLE",
    DOWNLOAD_DATA_BUTTONS__VIOLATEDROWS: "%VIOLATEDROWS",
    DQD_COMBINED_RESULTS__DETAIL: "Detail",
    DQD_COMBINED_RESULTS__LOADER_1: "Loading DQD overview",
    DQD_COMBINED_RESULTS__LOADER_2: "Loading DQD results",
    DQD_COMBINED_RESULTS__LOADER_MESSAGE_1: "Error loading DQD overview",
    DQD_COMBINED_RESULTS__LOADER_MESSAGE_2: "Error loading DQD results",
    DQD_COMBINED_RESULTS__OVERVIEW: "Overview",
    DQD_JOB_RESULTS__ERROR_DQD_OVERVIEW: "Error loading DQD overview: {0}",
    DQD_JOB_RESULTS__ERROR_DQD_RESULTS: "Error loading DQD results: {0}",
    DQD_JOB_RESULTS__INCORRECT_TABLETYPE: "Incorrect tableType supplied",
    DQD_JOB_RESULTS__LATEST_JOB_CANCELLED: "Latest job cancelled",
    DQD_JOB_RESULTS__LATEST_JOB_FAILED: "Latest job failed",
    DQD_JOB_RESULTS__LOADER_1: "Latest data characterization job is {0}",
    DQD_JOB_RESULTS__LOADER_2: "Latest data quality job is {0}",
    DQD_JOB_RESULTS__LOADER_3: "Loading data quality latest flow run",
    DQD_JOB_RESULTS__LOADER_4: "Loading DQD overview",
    DQD_JOB_RESULTS__LOADER_5: "Loading DQD results",
    DQD_JOB_RESULTS__NO_JOB_FOUND: "No job found",
    DQD_TABLE__COLUMN_CATEGORY_HEADER: "CATEGORY",
    DQD_TABLE__COLUMN_CONTEXT_HEADER: "CONTEXT",
    DQD_TABLE__COLUMN_DESCRIPTION_HEADER: "DESCRIPTION",
    DQD_TABLE__COLUMN_IS_ERROR_HEADER: "Is error",
    DQD_TABLE__COLUMN_LEVEL_HEADER: "LEVEL",
    DQD_TABLE__COLUMN_NOTES_HEADER: "NOTES",
    DQD_TABLE__COLUMN_NOT_APPLICABLE_HEADER: "Not applicable",
    DQD_TABLE__COLUMN_STATUS_HEADER: "STATUS",
    DQD_TABLE__COLUMN_SUBCATEGORY_HEADER: "SUBCATEGORY",
    DQD_TABLE__COLUMN_TABLE_HEADER: "TABLE",
    DQD_TABLE__COLUMN_VIOLATED_ROWS_HEADER: "%VIOLATEDROWS",
    DQD_TABLE__NO: "No",
    DQD_TABLE__RENDER_DETAIL_PANE_CHECK_ID: "Check id",
    DQD_TABLE__RENDER_DETAIL_PANE_CONCEPT_ID: "Concept id",
    DQD_TABLE__RENDER_DETAIL_PANE_ERROR_MESSAGE: "Error message",
    DQD_TABLE__RENDER_DETAIL_PANE_EXECUTION_TIME: "Execution time",
    DQD_TABLE__RENDER_DETAIL_PANE_FIELD: "Field",
    DQD_TABLE__RENDER_DETAIL_PANE_IS_ERROR: "Is error",
    DQD_TABLE__RENDER_DETAIL_PANE_LEVEL: "Level",
    DQD_TABLE__RENDER_DETAIL_PANE_NOT_APPLICABLE: "Not applicable",
    DQD_TABLE__RENDER_DETAIL_PANE_NUMBER_DENOMINATOR: "# Denominator rows",
    DQD_TABLE__RENDER_DETAIL_PANE_NUMBER_ROWS_VIOLATED: "# Rows violated",
    DQD_TABLE__RENDER_DETAIL_PANE_PERCENTAGE_ROWS_VIOLATED: "% Rows violated",
    DQD_TABLE__RENDER_DETAIL_PANE_SQL_QUERY: "SQL query",
    DQD_TABLE__RENDER_DETAIL_PANE_TABLE: "Table",
    DQD_TABLE__RENDER_DETAIL_PANE_UNIT_CONCEPT_ID: "Unit concept ID",
    DQD_TABLE__YES: "Yes",
    DQD__DATA_CHARACTERIZATION: "Data characterization",
    DQD__DETAIL: "Detail",
    DQD__JOB_STATUS: "Job status",
    DQD__LOADER: "Loading DQD jobs",
    DQD__OVERVIEW: "Overview",
    DQD__REFRESH: "Refresh table",
    DQD__SELECT: "Select a Study to view {0} results",
    DRILLDOWN_PREVALENCE_BY_MONTH_CHART__NO_DATA: "Results not available",
    DRILLDOWN_PREVALENCE_BY_MONTH_CHART__TITLE: "Prevalence by month",
    DRILLDOWN_PREVALENCE_BY_MONTH_CHART__TOOLTIP_FORMAT: "Date: {b}<br />Prevalence per 1000 people: {c}",
    DRILLDOWN_PREVALENCE_BY_MONTH_CHART__X_AXIS_NAME: "Date",
    DRILLDOWN_PREVALENCE_BY_MONTH_CHART__Y_AXIS_FORMAT: "{value}",
    DRILLDOWN_PREVALENCE_BY_MONTH_CHART__Y_AXIS_NAME: "Prevalence per 1000 people",
    DRILLDOWN_TRELLIS_CHART__NO_DATA: "Results not available",
    DRILLDOWN_TRELLIS_CHART__TITLE: "Prevalence",
    DRILLDOWN_TRELLIS_CHART__TRELLIS_BOTTOM_LABEL: "Years of observation",
    DRILLDOWN_TRELLIS_CHART__TRELLIS_TOP_LABEL: "Age decile",
    DRILLDOWN_TRELLIS_CHART__Y_AXIS_PREVALENCE_PER_1000_PEOPLE: "Prevalence per 1000 people",
    EDIT_DB_CREDENTIAL_DIALOG__AUTHENTICATION_MODE: "Authentication mode",
    EDIT_DB_CREDENTIAL_DIALOG__CANCEL: "Cancel",
    EDIT_DB_CREDENTIAL_DIALOG__CONNECTION_FAILED: "Connection failed",
    EDIT_DB_CREDENTIAL_DIALOG__CONNECTION_VERIFIED: "Connection verified",
    EDIT_DB_CREDENTIAL_DIALOG__CREDENTIALS: "Credentials",
    EDIT_DB_CREDENTIAL_DIALOG__DATABASE_CODE: "Database code",
    EDIT_DB_CREDENTIAL_DIALOG__EDIT_DATABASE_CREDENTIALS: "Edit database credentials",
    EDIT_DB_CREDENTIAL_DIALOG__ERROR: "An error has occurred.",
    EDIT_DB_CREDENTIAL_DIALOG__ERROR_DESCRIPTION:
      "Please try again. To report the error, please send an email to your administrator.",
    EDIT_DB_CREDENTIAL_DIALOG__PASSWORD: "Password",
    EDIT_DB_CREDENTIAL_DIALOG__PRIVILEGE: "Privilege",
    EDIT_DB_CREDENTIAL_DIALOG__SUCCESS: "Database {0} credentials updated",
    EDIT_DB_CREDENTIAL_DIALOG__TEST_CONNECTION: "Test connection",
    EDIT_DB_CREDENTIAL_DIALOG__TEST_CONNECTION_VALIDATE:
      "Please fill up the necessary information & credentials to test the connection",
    EDIT_DB_CREDENTIAL_DIALOG__UPDATE: "Update",
    EDIT_DB_CREDENTIAL_DIALOG__USERNAME: "Username",
    EDIT_DB_DETAILS_DIALOG__CACHE_REPLICATION: "Cache replication",
    EDIT_DB_DETAILS_DIALOG__CANCEL: "Cancel",
    EDIT_DB_DETAILS_DIALOG__CA_CERTIFICATE: "CA certificate",
    EDIT_DB_DETAILS_DIALOG__CA_HELPERTEXT:
      "Paste CA certificate in base64 format. E.g. curl -s https://truststore.pki.rds.amazonaws.com/global/global-bundle.pem | base64",
    EDIT_DB_DETAILS_DIALOG__CA_REQUIRED: "CA certificate is required when SSL mode is Verify CA or Verify Full.",
    EDIT_DB_DETAILS_DIALOG__DATABASE_ID: "Database ID",
    EDIT_DB_DETAILS_DIALOG__DATABASE_NAME: "Database name",
    EDIT_DB_DETAILS_DIALOG__DATABASE_NAME_REQUIRED: "Database name is required.",
    EDIT_DB_DETAILS_DIALOG__ERROR: "An error has occurred.",
    EDIT_DB_DETAILS_DIALOG__ERROR_DESCRIPTION:
      "Please try again. To report the error, please send an email to your administrator.",
    EDIT_DB_DETAILS_DIALOG__EXTRA: "Extra",
    EDIT_DB_DETAILS_DIALOG__FILL_REQUIRED_FIELDS: "Please fill in all required fields.",
    EDIT_DB_DETAILS_DIALOG__HOST: "Host",
    EDIT_DB_DETAILS_DIALOG__HOST_REQUIRED: "Host is required.",
    EDIT_DB_DETAILS_DIALOG__PORT: "Port",
    EDIT_DB_DETAILS_DIALOG__PORT_REQUIRED: "Port is required.",
    EDIT_DB_DETAILS_DIALOG__PRESS_ENTER: "Press enter to confirm the entry",
    EDIT_DB_DETAILS_DIALOG__PUBLICATION: "Publication",
    EDIT_DB_DETAILS_DIALOG__SSL_MODE: "SSL mode",
    EDIT_DB_DETAILS_DIALOG__SUCCESS: "Database {0} details updated",
    EDIT_DB_DETAILS_DIALOG__TITLE: "Edit database details",
    EDIT_DB_DETAILS_DIALOG__TLS_SSL: "TLS / SSL",
    EDIT_DB_DETAILS_DIALOG__UPDATE: "Update",
    EDIT_DB_DETAILS_DIALOG__VOCAB_SCHEMA: "Vocabulary / CDM schemas",
    EDIT_TENANT_ROLE_DIALOG__CANCEL: "Cancel",
    EDIT_TENANT_ROLE_DIALOG__EDIT: "Edit roles",
    EDIT_TENANT_ROLE_DIALOG__ROLES: "Roles",
    EDIT_TENANT_ROLE_DIALOG__SAVE: "Save",
    EDIT_TENANT_ROLE_DIALOG__SUCCESS: "User roles updated successfully",
    EXECUTE_FLOW_DIALOG__ERROR_DESCRIPTION:
      "Please try again. To report the error, please send an email to your administrator.",
    FEATURE__ADMIN_ONLY_SHARING: "Admin-only sharing",
    FEATURE__AI_ASSISTANT: "AI assistant",
    FEATURE__CDM_DOWNLOAD: "CDM download",
    FEATURE__CONCEPT_RECORD_COUNTS: "Concept record counts",
    FLOW_RUN_NOTIFICATION_DIALOG__CLOSE: "Close",
    FLOW_RUN_NOTIFICATION_DIALOG__VIEW_FLOW_RUN: "View flow run",
    FLOW_RUN_NOTIFICATION_DIALOG__PROGRESS_MESSAGE: "You can monitor its progress in the jobs page.",
    FEATURE__COHORT: "Cohort",
    FEATURE__CONCEPTS: "Concepts",
    FEATURE__DASHBOARD: "Dashboard",
    FEATURE__DATAFLOW: "Dataflow",
    FEATURE__ATLAS: "Atlas (experimental)",
    FEATURE__PYTHIA: "Pythia (Atlas AI assistant) (experimental)",
    FEATURE__DATASET_FILTER: "Dataset filter",
    FEATURE__DATASET_SEARCH: "Dataset search",
    FEATURE__DATA_MAPPING_SUGGESTION: "Data mapping AI suggestion",
    FEATURE__DOCKER_LOGS: "D2E Logs",
    FEATURE__ERROR: "An error has occurred.",
    FEATURE__ERROR_DESCRIPTION: "Please try again. To report the error, please send an email to your administrator.",
    FEATURE__ETL: "ETL",
    FEATURE__FEATURE_FLAGS: "Feature flags",
    FEATURE__FHIR_SERVER: "Fhir server",
    FEATURE__KAPLAN_MEIER: "Kaplan-Meier",
    FEATURE__NOTEBOOKS: "Notebooks",
    FEATURE__PATIENT_ANALYTICS: "Patient analytics",
    FEATURE__SAVE: "Save",
    FEATURE__STRATEGUS: "Strategus",
    FEATURE__SUCCESS: "Changes saved",
    FEATURE__TERMINOLOGY: "Terminology",
    FEATURE__TREX_PLUGINS: "Plugin management",
    FEATURE__WIZARDS: "Wizards",
    GIT_CONFIG__BRANCH_LABEL: "Default Branch",
    GIT_CONFIG__CONFIGURE_FIRST: "Please configure the dataflow Git repository URL and branch first.",
    GIT_CONFIG__DATAFLOW_SECTION: "Dataflow Git Configuration",
    GIT_CONFIG__ERROR: "Failed to save Git configuration",
    GIT_CONFIG__NOTEBOOK_SECTION: "Notebook Git Configuration",
    GIT_CONFIG__OVERWRITE_DIALOG_CONFIRM: "Overwrite All",
    GIT_CONFIG__OVERWRITE_DIALOG_CREATE_NEW: "Create new local flows with version 1",
    GIT_CONFIG__OVERWRITE_DIALOG_DELETE_FLOWS: "Delete all existing local data transformation flows",
    GIT_CONFIG__OVERWRITE_DIALOG_DELETE_HISTORY: "Delete all local flow revisions and history",
    GIT_CONFIG__OVERWRITE_DIALOG_DESCRIPTION: "This operation will:",
    GIT_CONFIG__OVERWRITE_DIALOG_IMPORT_FLOWS: "Import all flows from the remote Git repository",
    GIT_CONFIG__OVERWRITE_DIALOG_PROCESSING: "Processing...",
    GIT_CONFIG__OVERWRITE_DIALOG_TITLE: "Overwrite All Local Flows",
    GIT_CONFIG__OVERWRITE_DIALOG_WARNING_MESSAGE:
      "All local changes not synchronized to the remote repository will be permanently lost.",
    GIT_CONFIG__OVERWRITE_DIALOG_WARNING_TITLE: "Warning:",
    GIT_CONFIG__OVERWRITE_NOTEBOOKS_DIALOG_CONFIRM: "Overwrite All",
    GIT_CONFIG__OVERWRITE_NOTEBOOKS_DIALOG_CREATE_NEW: "Create new local notebooks with version 1",
    GIT_CONFIG__OVERWRITE_NOTEBOOKS_DIALOG_DELETE_CONTENT: "Delete all local notebook content",
    GIT_CONFIG__OVERWRITE_NOTEBOOKS_DIALOG_DELETE_NOTEBOOKS: "Delete all existing local notebooks",
    GIT_CONFIG__OVERWRITE_NOTEBOOKS_DIALOG_DESCRIPTION: "This operation will:",
    GIT_CONFIG__OVERWRITE_NOTEBOOKS_DIALOG_IMPORT_NOTEBOOKS: "Import all notebooks from the remote Git repository",
    GIT_CONFIG__OVERWRITE_NOTEBOOKS_DIALOG_PROCESSING: "Processing...",
    GIT_CONFIG__OVERWRITE_NOTEBOOKS_DIALOG_TITLE: "Overwrite All Local Notebooks",
    GIT_CONFIG__OVERWRITE_NOTEBOOKS_DIALOG_WARNING_MESSAGE:
      "All local changes not synchronized to the remote repository will be permanently lost.",
    GIT_CONFIG__OVERWRITE_NOTEBOOKS_DIALOG_WARNING_TITLE: "Warning:",
    GIT_CONFIG__PAT_LABEL: "Personal Access Token (PAT)",
    GIT_CONFIG__REPO_URL_LABEL: "Repository URL",
    GIT_CONFIG__SAVE: "Save",
    GIT_CONFIG__SUCCESS: "Git configuration saved successfully",
    GIT_CONFIG__SYNC_ALL_FLOWS: "Synchronize all flows from remote",
    GIT_CONFIG__SYNC_ALL_NOTEBOOKS: "Synchronize all notebooks from remote",
    GIT_CONFIG__SYNC_FLOWS_ERROR: "Failed to import flows from remote repository.",
    GIT_CONFIG__SYNC_FLOWS_SUCCESS: "Successfully imported {0} flows from remote repository.",
    GIT_CONFIG__SYNC_NOTEBOOKS_ERROR: "Failed to import notebooks from remote repository.",
    GIT_CONFIG__SYNC_NOTEBOOKS_SUCCESS: "Successfully imported {0} notebooks from remote repository.",
    GIT_CONFIG__TITLE: "Git Repository Configuration",
    HISTORICAL_DATA_QUALITY_CHART__NO_DATA: "No data",
    HISTORICAL_DATA_QUALITY_CHART__TITLE: "Historical data quality",
    HISTORICAL_DATA_QUALITY_CHART__X_AXIS_NAME: "CDM Release Date",
    HISTORICAL_DATA_QUALITY_CHART__Y_AXIS_NAME: "Checks failed",
    HISTORICAL_DATA_QUALITY_MULTI_SERIES_CHART__NO_DATA: "No data",
    HISTORICAL_DATA_QUALITY_MULTI_SERIES_CHART__TITLE: "Historical data quality by {0}",
    HISTORICAL_DATA_QUALITY_MULTI_SERIES_CHART__X_AXIS_NAME: "CDM Release Date",
    HISTORICAL_DATA_QUALITY_MULTI_SERIES_CHART__Y_AXIS_NAME: "Checks failed",
    HISTORY_TABLE__ACTION: "Action",
    HISTORY_TABLE__CANCEL_JOB: "Cancel job",
    HISTORY_TABLE__COHORT_DEFINITION_ID: "Cohort definition ID",
    HISTORY_TABLE__COMMENT: "Comment",
    HISTORY_TABLE__COMPLETED_TIME: "Completed time",
    HISTORY_TABLE__CREATED_TIME: "Created time",
    HISTORY_TABLE__DATABASE: "Database",
    HISTORY_TABLE__DC_SCHEMA: "Data characterization schema",
    HISTORY_TABLE__NO_JOBS: "No jobs found",
    HISTORY_TABLE__SCHEMA: "Schema",
    HISTORY_TABLE__STATUS: "Status",
    HISTORY_TABLE__STATUS_DETAIL: "Status detail",
    HISTORY_TABLE__STUDY: "Study",
    HISTORY_TABLE__TYPE: "Type",
    HISTORY_TABLE__VIEW_DETAIL: "View detail",
    HEADER_IMAGE__ERROR_INVALID_TYPE: "Invalid file type. Please upload a PNG or JPEG image.",
    HEADER_IMAGE__ERROR_TOO_LARGE: "File is too large. Maximum size is 1MB.",
    HEADER_IMAGE__HINT: "Accepted formats: PNG, JPEG. Max size: 1MB. Recommended: 320 x 214 px.",
    HEADER_IMAGE__PLACEHOLDER_DESCRIPTION: "Configure your overview description text.",
    HEADER_IMAGE__RESTORE_DEFAULT: "Restore default",
    HEADER_IMAGE__TITLE: "Header image",
    HEADER_IMAGE__UPLOAD: "Upload image",
    HOME__DESCRIPTION:
      "Our vision is a world where health data is comprehensively, digitally, and securely available for research and directly impacts the prevention, diagnosis, and treatment of diseases.",
    HYBRID_SEARCH__CONFIGURATION: "Hybrid search configuration",
    HYBRID_SEARCH__ENABLE: "Enable hybrid search",
    HYBRID_SEARCH__ERROR: "An error has occurred.",
    HYBRID_SEARCH__ERROR_DESCRIPTION:
      "Please try again. To report the error, please send an email to your administrator.",
    HYBRID_SEARCH__SAVE: "Save",
    HYBRID_SEARCH__SEMANTIC_RATIO: "Semantic ratio",
    HYBRID_SEARCH__SEMANTIC_RATIO_ERROR: "Semantic ratio must have a value between 0 and 1",
    HYBRID_SEARCH__SUCCESS: "Changes saved",
    IMPRINT__TITLE: "Imprint",
    INFORMATION__DATABASE_NAME_UNDEFINED: "Error: Schema Name or Database Name is undefined ",
    INFORMATION__DATASET: "Dataset",
    INFORMATION__DOWNLOAD: "Download",
    INFORMATION__DOWNLOAD_FILE: "Download file",
    INFORMATION__FEEDBACK_ERROR_DESCRIPTION:
      "Please try again. To report the error, please send an email to your administrator.",
    INFORMATION__FEEDBACK_ERROR_MESSAGE: "An error has occurred.",
    INFORMATION__FEEDBACK_MESSAGE: "Request has been sent",
    INFORMATION__FILENAME: "Filename",
    INFORMATION__FILES: "Files",
    INFORMATION__METADATA: "Metadata",
    INFORMATION__NO_DATASET_DESCRIPTION: "No dataset description available",
    INFORMATION__NO_FILE_AVAILABLE: "No file available",
    INFORMATION__OVERVIEW: "Overview",
    INFORMATION__PENDING_APPROVAL: "Pending approval",
    INFORMATION__REQUEST_ACCESS: "Request access",
    INFORMATION__RESOURCE_TYPE: "Resource type",
    INFORMATION__RESULTS: "Results",
    INFORMATION__SCHEMA_NAME_UNDEFINED: "Error: Schema Name is undefined ",
    INFORMATION__SIZE: "Size",
    INFORMATION__TAB_DATASET_INFO: "Dataset info",
    INFORMATION__TAB_DATA_CHARACTERIZATION: "Data characterization",
    INFORMATION__TAB_DATA_QUALITY: "Data quality",
    INFORMATION__TAGS: "Tags",
    INFORMATION__UNTITLED: "Untitled",
    JOBS__DATA_QUALITY_ANALYSIS: "Data quality analysis",
    JOB_DIALOG__CANCEL: "Cancel",
    JOB_DIALOG__COMMENT: "Comment",
    JOB_DIALOG__ERROR: "An error has occurred when trying to create a {0} Job",
    JOB_DIALOG__ERROR_DESCRIPTION: "Please try again. To report the error, please send an email to your administrator.",
    JOB_DIALOG__GENERATE: "Generate",
    JOB_DIALOG__GENERATE_DATA_CHARACTERIZATION: "Generate data characterization",
    JOB_DIALOG__GENERATE_DATA_QUALITY: "Generate data quality",
    JOB_DIALOG__GENERATING_JOB: "Generating job",
    JOB_DIALOG__SUCCESS: "{0} job successfully started.",
    JOB_RUN_BUTTONS__NO_DATA_QUALITY_JOB_TOOLTIP: "Data quality job not installed",
    JOB_RUN_BUTTONS__RUN_DATA_CHARACTERIZATION: "Run data characterization",
    JOB_RUN_BUTTONS__RUN_DATA_QUALITY: "Run data quality",
    JOB_TABLE__NO_DATA: "No data available",
    MANAGE_DASHBOARD_DIALOG__CANCEL: "Cancel",
    MANAGE_DASHBOARD_DIALOG__SAVE: "Save",
    MANAGE_DASHBOARD_DIALOG__SAVE_ERROR: "Failed to save code",
    MANAGE_DASHBOARD_DIALOG__SAVE_SUCCESS: "Code saved successfully",
    MANAGE_DASHBOARD_DIALOG__STARTING_VIEWER: "Starting viewer...",
    MANAGE_DASHBOARD_DIALOG__START_VIEWER: "Start viewer",
    MANAGE_DASHBOARD_DIALOG__STOPPING_VIEWER: "Stopping viewer...",
    MANAGE_DASHBOARD_DIALOG__STOP_VIEWER: "Stop viewer",
    MANAGE_DASHBOARD_DIALOG__TITLE: "Edit dashboard viewer code for {0}",
    MANAGE_DASHBOARD_DIALOG__VIEWER_STATUS: "Viewer status: {0}",
    MANAGE_STRATEGUS_RESULT_VIEWER_DIALOG__CANCEL: "Cancel",
    MANAGE_STRATEGUS_RESULT_VIEWER_DIALOG__SAVE: "Save",
    MANAGE_STRATEGUS_RESULT_VIEWER_DIALOG__SAVE_ERROR: "Failed to save code",
    MANAGE_STRATEGUS_RESULT_VIEWER_DIALOG__SAVE_SUCCESS: "Code saved successfully",
    MANAGE_STRATEGUS_RESULT_VIEWER_DIALOG__STARTING_VIEWER: "Starting viewer...",
    MANAGE_STRATEGUS_RESULT_VIEWER_DIALOG__START_VIEWER: "Start viewer",
    MANAGE_STRATEGUS_RESULT_VIEWER_DIALOG__STOPPING_VIEWER: "Stopping viewer...",
    MANAGE_STRATEGUS_RESULT_VIEWER_DIALOG__STOP_VIEWER: "Stop viewer",
    MANAGE_STRATEGUS_RESULT_VIEWER_DIALOG__TITLE: "Edit viewer code for {0}",
    MANAGE_STRATEGUS_RESULT_VIEWER_DIALOG__VIEWER_STATUS: "Viewer status: {0}",
    MANAGE_VIEWER_DIALOG__BUILD_SHINY: "Build Shiny assets",
    MANAGE_VIEWER_DIALOG__COHORT: "Cohort",
    MANAGE_VIEWER_DIALOG__CONFIG_TYPE: "Config type",
    MANAGE_VIEWER_DIALOG__DASHBOARD: "Dashboard",
    MANAGE_VIEWER_DIALOG__NAME_NO_SPACES: "Name cannot contain spaces",
    MANAGE_VIEWER_DIALOG__SHINY_BUILD_ERROR: "Failed to trigger shiny assets build.",
    MANAGE_VIEWER_DIALOG__SHINY_BUILD_SUCCESS: "Shiny assets build triggered successfully.",
    MANAGE_VIEWER_DIALOG__VIEWER_TYPE: "Viewer type",
    MENU_NAV__DATASET: "Dataset",
    METADATA_FORM__REQUIRED: "This is required",
    METADATA_FORM__VALUE: "Value",
    MORE_ACTION_BUTTON__CHANGE_PASSWORD: "Change password",
    NO_ACCESS__ACCESS_DENIED: "Access denied.",
    NO_ACCESS__INFO: "Please check with your administrator to request access",
    OBSERVATION_PERIOD_CUMULATIVE_DURATION_CHART__NO_DATA: "Results not available",
    OBSERVATION_PERIOD_CUMULATIVE_DURATION_CHART__TITLE: "Cumulative observation",
    OBSERVATION_PERIOD_CUMULATIVE_DURATION_CHART__TOOLTIP_FORMAT: "Years: {b}<br />Percent of population: {c}%",
    OBSERVATION_PERIOD_CUMULATIVE_DURATION_CHART__X_AXIS_NAME: "Years",
    OBSERVATION_PERIOD_CUMULATIVE_DURATION_CHART__Y_AXIS_FORMAT: "{value}%",
    OBSERVATION_PERIOD_CUMULATIVE_DURATION_CHART__Y_AXIS_NAME: "Percent of population",
    OBSERVATION_PERIOD_OBSERVED_BY_MONTH_CHART__NO_DATA: "Results not available",
    OBSERVATION_PERIOD_OBSERVED_BY_MONTH_CHART__TITLE: "Persons with continuous observation by month",
    OBSERVATION_PERIOD_OBSERVED_BY_MONTH_CHART__TOOLTIP_FORMAT: "Date: {b}<br />People: {c}",
    OBSERVATION_PERIOD_OBSERVED_BY_MONTH_CHART__X_AXIS_NAME: "Date",
    OBSERVATION_PERIOD_OBSERVED_BY_MONTH_CHART__Y_AXIS_NAME: "People",
    OBSERVATION_PERIOD__AGE_AT_FIRST_OBSERVATION_CHART_TITLE: "Age at first observation",
    OBSERVATION_PERIOD__AGE_AT_FIRST_OBSERVATION_CHART_TOOLTIP_FORMAT: "Age: {b}<br />Number of people: {c}",
    OBSERVATION_PERIOD__AGE_AT_FIRST_OBSERVATION_CHART_X_AXIS_NAME: "Age",
    OBSERVATION_PERIOD__AGE_AT_FIRST_OBSERVATION_CHART_Y_AXIS_NAME: "People",
    OBSERVATION_PERIOD__BAR_CHART_2_TITLE: "Observation length",
    OBSERVATION_PERIOD__BAR_CHART_2_TOOLTIP_FORMAT: "Year: {b}<br />People: {c}",
    OBSERVATION_PERIOD__BAR_CHART_2_X_AXIS_NAME: "Years",
    OBSERVATION_PERIOD__BAR_CHART_2_Y_AXIS_NAME: "People",
    OBSERVATION_PERIOD__BAR_CHART_3_TITLE: "Persons with continuous observation by year",
    OBSERVATION_PERIOD__BAR_CHART_3_TOOLTIP_FORMAT: "Year: {b}<br />People: {c}",
    OBSERVATION_PERIOD__BAR_CHART_3_X_AXIS_NAME: "Years",
    OBSERVATION_PERIOD__BAR_CHART_3_Y_AXIS_NAME: "People",
    OBSERVATION_PERIOD__BOX_PLOT_CHART_1_TITLE: "Age by gender",
    OBSERVATION_PERIOD__BOX_PLOT_CHART_1_X_AXIS_NAME: "Gender",
    OBSERVATION_PERIOD__BOX_PLOT_CHART_1_Y_AXIS_NAME: "Age",
    OBSERVATION_PERIOD__BOX_PLOT_CHART_2_TITLE: "Duration by gender",
    OBSERVATION_PERIOD__BOX_PLOT_CHART_2_X_AXIS_NAME: "Gender",
    OBSERVATION_PERIOD__BOX_PLOT_CHART_2_Y_AXIS_NAME: "Years",
    OBSERVATION_PERIOD__BOX_PLOT_CHART_3_TITLE: "Duration by age decile",
    OBSERVATION_PERIOD__BOX_PLOT_CHART_3_X_AXIS_NAME: "Age decile",
    OBSERVATION_PERIOD__BOX_PLOT_CHART_3_Y_AXIS_NAME: "Years",
    OBSERVATION_PERIOD__ERROR_MESSAGE: "Error occurred when fetching data characterization observationPeriod data",
    OBSERVATION_PERIOD__LOADER: "Loading observation period reports",
    OBSERVATION_PERIOD__PIE_CHART_TITLE: "Observation periods per person",
    OIDC_CALLBACK_SUCCESS__LOADER: "Authentication completed. Redirecting...",
    OIDC_ERROR__MESSAGE: "Error occurred while authenticating",
    OIDC_SESSION_LOST__BUTTON: "Logout",
    OIDC_TOKEN__THIRD_PARTY_TOKEN_MISSING: "The user session is incomplete. Please log out and log in again.",
    OVERVIEW_DESCRIPTION__DISPLAY_DISCLAIMER: "Display disclaimer when logged in",
    OVERVIEW_DESCRIPTION__DISPLAY_IMPRINT: "Display imprint",
    OVERVIEW_DESCRIPTION__DISPLAY_PRIVACY_POLICY: "Display privacy policy",
    OVERVIEW_DESCRIPTION__DISPLAY_TERMS_OF_USE: "Display terms of use",
    OVERVIEW_DESCRIPTION__DISPLAY_DATA_QUALITY_DESCRIPTION: "Display data quality description",
    DATA_QUALITY_DESCRIPTION__TITLE: "Data quality description",
    OVERVIEW_DESCRIPTION__DISCARD_CHANGES: "Discard changes",
    OVERVIEW_DESCRIPTION__SAVE: "Save",
    OVERVIEW_DESCRIPTION__SUCCESS_MESSAGE: "Changes saved",
    OVERVIEW_DESCRIPTION__TITLE: "Overview description",
    OVERVIEW_TABLE__CATEGORY_COMPLETENESS: "Completeness",
    OVERVIEW_TABLE__CATEGORY_CONFORMANCE: "Conformance",
    OVERVIEW_TABLE__CATEGORY_PLAUSIBILITY: "Plausibility",
    OVERVIEW_TABLE__CATEGORY_TOTAL: "Total",
    OVERVIEW_TABLE__FAIL: "Fail",
    OVERVIEW_TABLE__NOTE_1: "{0} out of {1} passed checks are not applicable, due to empty tables or fields.",
    OVERVIEW_TABLE__NOTE_2: "{0} out of {1} failed checks are SQL errors.",
    OVERVIEW_TABLE__NOTE_3: "Corrected pass percentage for NA and Errors: {0} ({1}/{2}).",
    OVERVIEW_TABLE__PASS: "Pass",
    OVERVIEW_TABLE__PCT_PASS: "% Pass",
    OVERVIEW_TABLE__TOTAL: "Total",
    OVERVIEW_TABLE__VALIDATION: "Validation",
    OVERVIEW_TABLE__VERIFICATION: "Verification",
    OVERVIEW__NO_DATASET: "No dataset available",
    PERMISSIONS_DIALOG__ACCESS: "Access",
    PERMISSIONS_DIALOG__CLOSE: "Close",
    PERMISSIONS_DIALOG__ERROR: "Error while saving. {0}",
    PERMISSIONS_DIALOG__PERMISSIONS: "Permissions",
    PERMISSIONS_DIALOG__REQUEST: "Request",
    PERMISSIONS_DIALOG__SAVE: "Save",
    PERMISSIONS_DIALOG__SUCCESS: "Saved successfully",
    PERSON__BAR_CHART_TITLE: "Year of birth",
    PERSON__BAR_CHART_TOOLTIP_FORMAT: "Year: {b}<br /># of persons: {c}",
    PERSON__BAR_CHART_X_AXIS_NAME: "Year",
    PERSON__BAR_CHART_Y_AXIS_NAME: "# of persons",
    PERSON__ERROR_MESSAGE: "Error occurred when fetching data characterization person data",
    PERSON__LOADER: "Loading person reports",
    PERSON__PIE_CHART_1_TITLE: "Gender",
    PERSON__PIE_CHART_2_TITLE: "Race",
    PERSON__PIE_CHART_3_TITLE: "Ethnicity",
    PIE_CHART__NO_DATA: "Results not available",
    PLUGIN_MENU_ITEM__TITLE: "Plugins",
    PLUGIN_TABLE__NO_DATA: "No data available",
    PRIVACY_POLICY__TITLE: "Privacy policy",
    PUBLIC_DATASET_CARD__DATA_MODEL: "Data model",
    PUBLIC_DATASET_CARD__DATE: "Date",
    PUBLIC_DATASET_CARD__NO_DATASET_SUMMARY: "No dataset summary available",
    PUBLIC_DATASET_CARD__PATIENT_COUNT: "Total subjects",
    PUBLIC_DATASET_CARD__VERSION: "Version",
    PUBLIC_INFORMATION__DATASET: "Dataset",
    PUBLIC_INFORMATION__DATASET_ID: "Dataset ID",
    PUBLIC_INFORMATION__METADATA: "Metadata",
    PUBLIC_INFORMATION__NO_DATASET_DESCRIPTION: "No dataset description available",
    PUBLIC_INFORMATION__RESOURCE_TYPE: "Resource type",
    PUBLIC_INFORMATION__TAB_DATASET_INFO: "Dataset info",
    PUBLIC_INFORMATION__TAGS: "Tags",
    PUBLIC_INFORMATION__UNTITLED: "Untitled",
    PUBLIC_STUDY_OVERVIEW_NAV__DATASET: "Dataset",
    PUBLIC__NAVIGATION_LEGAL: "Legal",
    PUBLIC__NAVIGATION_LOGIN: "Login",
    QUERIES_SECTION__ADD_QUERY: "Add query",
    QUERIES_SECTION__QUERIES: "Queries",
    QUERIES_SECTION__QUERY_NAME: "Query name",
    QUERIES_SECTION__REMOVE: "Remove",
    QUERIES_SECTION__SQL: "SQL",
    RELEASE_SELECTOR__RELEASE_SELECTION: "Release selection",
    REQUEST_PANEL__APPROVE: "Approve",
    REQUEST_PANEL__NAME: "Name",
    REQUEST_PANEL__NO_DATA: "No data available",
    REQUEST_PANEL__REJECT: "Reject",
    REQUEST_PANEL__REQUESTED: "Requested on",
    REQUEST_PANEL__REQUESTS: "Requests",
    REQUEST_PANEL__SELECT_ACTION: "Select action",
    RESULTS_DIALOG__RESULTS: "Results for dataset: {0} ({1})",
    ROLES_SELECT__EDIT: "Edit role",
    RUN_STRATEGUS_DIALOG__CANCEL: "Cancel",
    RUN_STRATEGUS_DIALOG__CHOOSE_DATASET: "Choose a dataset",
    RUN_STRATEGUS_DIALOG__ERROR_START_STUDY: 'Failed to start study "{0}"',
    RUN_STRATEGUS_DIALOG__RUN_STUDY: "Run study",
    RUN_STRATEGUS_DIALOG__SELECT_DATASET: "Select a dataset:",
    RUN_STRATEGUS_DIALOG__SUCCESS_FLOW_RUN_ID: "Flow run ID: {0}",
    RUN_STRATEGUS_DIALOG__SUCCESS_STUDY_STARTED: 'Study "{0}" started successfully',
    RUN_STRATEGUS_DIALOG__TITLE: "Run Strategus study",
    SAMPLE_RESEARCHER_STUDY__GET_JWT_TOKEN: "Get JWT token",
    SAMPLE_RESEARCHER_STUDY__HELLO: "Hello {0}",
    SAMPLE_RESEARCHER_STUDY__STUDY: "Study {0}",
    SAMPLE_RESEARCHER_STUDY__TITLE: "[Built-in] Researcher study plugin page",
    SAVE_ATTRIBUTE_DIALOG__ADD: "Add attribute",
    SAVE_ATTRIBUTE_DIALOG__ATTRIBUTE_ID: "Attribute ID",
    SAVE_ATTRIBUTE_DIALOG__ATTRIBUTE_NAME: "Attribute name",
    SAVE_ATTRIBUTE_DIALOG__CANCEL: "Cancel",
    SAVE_ATTRIBUTE_DIALOG__CATEGORY: "Category",
    SAVE_ATTRIBUTE_DIALOG__DATATYPE: "Datatype",
    SAVE_ATTRIBUTE_DIALOG__EDIT: "Edit attribute",
    SAVE_ATTRIBUTE_DIALOG__SAVE: "Save",
    SAVE_ATTRIBUTE_DIALOG__SUCCESS: "Attribute config added successfully.",
    SAVE_ATTRIBUTE_DIALOG__EDIT_SUCCESS: "Attribute config edited successfully.",
    SAVE_DB_DIALOG__ADD_DATABASE: "Add database",
    SAVE_DB_DIALOG__AUTHENTICATION_MODE: "Authentication mode",
    SAVE_DB_DIALOG__CACHE_REPLICATION: "Cache replication",
    SAVE_DB_DIALOG__CANCEL: "Cancel",
    SAVE_DB_DIALOG__CA_CERTIFICATE: "CA certificate",
    SAVE_DB_DIALOG__CA_HELPERTEXT:
      "Paste CA certificate in base64 format. E.g. curl -s https://truststore.pki.rds.amazonaws.com/global/global-bundle.pem | base64",
    SAVE_DB_DIALOG__CONNECTION_FAILED: "Connection failed",
    SAVE_DB_DIALOG__CONNECTION_VERIFIED: "Connection verified",
    SAVE_DB_DIALOG__CREDENTIALS: "Credentials",
    SAVE_DB_DIALOG__DATABASE_ID: "Database ID",
    SAVE_DB_DIALOG__DATABASE_NAME: "Database name",
    SAVE_DB_DIALOG__DIALECT: "Dialect",
    SAVE_DB_DIALOG__ENTER_VALID_JSON_DATA_PLATFORM: "Please enter a valid JSON value in Extra for Data Platform.",
    SAVE_DB_DIALOG__ENTER_VALID_JSON_INTERNAL: "Please enter a valid JSON value in Extra for Internal.",
    SAVE_DB_DIALOG__ERROR: "An error has occurred.",
    SAVE_DB_DIALOG__ERROR_MESSAGE: "Please try again. To report the error, please send an email to your administrator.",
    SAVE_DB_DIALOG__EXTRA: "Extra",
    SAVE_DB_DIALOG__EXTRA_INVALID_JSON:
      "Invalid JSON in Extra (Internal). Please correct the JSON before testing the connection.",
    SAVE_DB_DIALOG__HOST: "Host",
    SAVE_DB_DIALOG__PASSWORD: "Password",
    SAVE_DB_DIALOG__PORT: "Port",
    SAVE_DB_DIALOG__PRESS_ENTER: "Press enter to confirm the entry",
    SAVE_DB_DIALOG__PRIVILEGE: "Privilege",
    SAVE_DB_DIALOG__PUBLICATION: "Publication",
    SAVE_DB_DIALOG__SAVE: "Save",
    SAVE_DB_DIALOG__SSL_MODE: "SSL mode",
    SAVE_DB_DIALOG__SUCCESS: "Database added successfully",
    SAVE_DB_DIALOG__TEST_CONNECTION: "Test connection",
    SAVE_DB_DIALOG__TEST_CONNECTION_VALIDATE:
      "Please fill up the necessary information & credentials to test the connection",
    SAVE_DB_DIALOG__TLS_SSL: "TLS / SSL",
    SAVE_DB_DIALOG__USERNAME: "Username",
    SAVE_DB_DIALOG__VALUE: "Value (in JSON format)",
    SAVE_DB_DIALOG__VOCAB_SCHEMAS: "Vocabulary / CDM schemas",
    SCHEMA_FILTER__LOADER: "Loading schema definition...",
    SCHEMA_FILTER__TEXT: "Select table filter",
    SEARCH_BAR_DATASET__PLACEHOLDER: "Search datasets",
    SEARCH_BAR__SEARCH: "Search",
    SEARCH_BAR__SEARCH_TERMS: "search terms",
    SELECT_DATASET__SELECT_DATASET: "Dataset",
    SELECT_RELEASE__SELECT_CURRENT: "Current",
    SELECT_RELEASE__SELECT_RELEASE: "Release",
    SETUP_MENU_ITEM__CONFIGURE: "Configure",
    SETUP_OVERVIEW__BACK: "Back to Setup",
    SETUP_OVERVIEW__SETUP: "Setup",
    SHARED_DRILLDOWN__BAR_CHART_TITLE: "Frequency distribution",
    SHARED_DRILLDOWN__BAR_CHART_TOOLTIP_FORMAT: "Count: {b}<br />% of total number of persons: {c}",
    SHARED_DRILLDOWN__BAR_CHART_X_AXIS_NAME: 'Count ("x" or more Procedures)',
    SHARED_DRILLDOWN__BAR_CHART_Y_AXIS_NAME: "% of total number of persons",
    SHARED_DRILLDOWN__BOX_PLOT_CHART_1_TITLE: "Age at first occurrence",
    SHARED_DRILLDOWN__BOX_PLOT_CHART_1_X_AXIS_NAME: "Gender",
    SHARED_DRILLDOWN__BOX_PLOT_CHART_1_Y_AXIS_NAME: "Age at first occurrence",
    SHARED_DRILLDOWN__BOX_PLOT_CHART_2_TITLE: "Length of era distribution",
    SHARED_DRILLDOWN__BOX_PLOT_CHART_2_X_AXIS_NAME: "Length of era",
    SHARED_DRILLDOWN__BOX_PLOT_CHART_2_Y_AXIS_NAME: "Days",
    SHARED_DRILLDOWN__ERROR_MESSAGE: "Error occurred when fetching data characterization {0} data",
    SHARED_DRILLDOWN__LOADER: "Loading {0} reports",
    SHARED_DRILLDOWN__PIE_CHART_1_TITLE: "Value as concept",
    SHARED_DRILLDOWN__PIE_CHART_2_TITLE: "Operator concept",
    SHARED_DRILLDOWN__PIE_CHART_3_TITLE: "Qualifier concept",
    SHARED_DRILLDOWN__PIE_CHART_4_TITLE: "Measurement records by unit",
    SIDE_DROPDOWN__OPEN_IN_NEW_TAB: "Open in new tab",
    REFRESH_CACHE_DIALOG__TITLE: "Refresh cache for {0}",
    REFRESH_CACHE_DIALOG__DESCRIPTION:
      "This rebuilds the cache for {0} from its current data model. It runs in the background and may take a few minutes.",
    REFRESH_CACHE_DIALOG__CONFIRM: "Refresh",
    REFRESH_CACHE_DIALOG__CANCEL: "Cancel",
    REFRESH_CACHE_DIALOG__STARTED: "Cache refresh started.",
    REFRESH_CACHE_DIALOG__MISSING_DATASET_ID: "Dataset ID is missing.",
    REFRESH_CACHE_DIALOG__ERROR: "An error has occurred.",
    SOURCE_INFORMATION_DIALOG__CACHE_SECTION: "Cache",
    SOURCE_INFORMATION_DIALOG__CACHE_LAST_REFRESHED: "Last refreshed: {0}",
    SOURCE_INFORMATION_DIALOG__CACHE_BUILDING: "Cache is being built…",
    SOURCE_INFORMATION_DIALOG__NO_CACHE: "No cache yet",
    SOURCE_INFORMATION_DIALOG__DATABASE_CODE: "Database code",
    SOURCE_INFORMATION_DIALOG__DATASET_NAME: "Dataset name",
    SOURCE_INFORMATION_DIALOG__TITLE: "Source information",
    SOURCE_INFORMATION_DIALOG__TOKEN_CODE: "Token dataset code",
    STUDY_CARD__BACK: "Back",
    STUDY_CARD__CLEANING_UP: "Cleaning up...",
    STUDY_CARD__CLEANUP_STUDY: "Cleanup study",
    STUDY_CARD__EDIT_VIEWER: "Edit viewer",
    STUDY_CARD__ERROR_CLEANUP_STUDY: 'Failed to cleanup study "{0}"',
    STUDY_CARD__ERROR_FETCH_STRATEGUS_JSON: "Could not fetch strategus JSON from repository",
    STUDY_CARD__ERROR_FETCH_STRATEGUS_JSON_DESCRIPTION: "Please check if the study configuration is available.",
    STUDY_CARD__ERROR_START_STUDY: 'Failed to start study "{0}"',
    STUDY_CARD__ERROR_START_VIEWER: "Failed to start study viewer for {0}",
    STUDY_CARD__ERROR_STOP_VIEWER: "Failed to stop study viewer for {0}",
    STUDY_CARD__NO_STUDY_SUMMARY: "No study summary available",
    STUDY_CARD__OPEN_VIEWER: "Open viewer",
    STUDY_CARD__RESULTS_VIEWER: "Results viewer - ",
    STUDY_CARD__RUNNING: "Running...",
    STUDY_CARD__RUN_STUDY: "Run study",
    STUDY_CARD__STARTING_VIEWER: "Starting viewer...",
    STUDY_CARD__START_VIEWER: "Start viewer",
    STUDY_CARD__STOPPING_VIEWER: "Stopping viewer...",
    STUDY_CARD__STOP_VIEWER: "Stop viewer",
    STUDY_CARD__SUCCESS_FLOW_RUN_ID: "Flow run ID: {0}",
    STUDY_CARD__SUCCESS_STUDY_CLEANUP: 'Study "{0}" cleanup completed successfully',
    STUDY_CARD__SUCCESS_STUDY_STARTED: 'Study "{0}" started successfully',
    STUDY_CARD__SUCCESS_VIEWER_STARTED: "Result viewer for {0} started successfully",
    STUDY_CARD__SUCCESS_VIEWER_STOPPED: "Result viewer for {0} stopped successfully",
    STUDY_CARD__UNTITLED: "Untitled",
    STUDY_NAV__NO_STUDY: "No study",
    STUDY_NAV__UNTITLED: "Untitled",
    STUDY_OVERVIEW__ACTIONS: "Actions",
    STUDY_OVERVIEW__ADD_DATASET: "Add dataset",
    STUDY_OVERVIEW__ADD_STUDY: "Add study",
    STUDY_OVERVIEW__CACHE_DATASETS: "Cache datasets",
    STUDY_OVERVIEW__CDM_DATASETS: "CDM datasets",
    STUDY_OVERVIEW__CREATED_AT: "Created at",
    STUDY_OVERVIEW__DATASETS: "Datasets",
    STUDY_OVERVIEW__DATASET_ID: "Dataset ID",
    STUDY_OVERVIEW__DATA_MODEL: "Data model",
    STUDY_OVERVIEW__DOWNLOAD_STRATEGUS_ERROR_NOT_FOUND:
      "No results file found for study {0}. Please upload results first.",
    STUDY_OVERVIEW__FHIR_DATASETS: "FHIR datasets",
    STUDY_OVERVIEW__FHIR_SERVER: "FHIR server",
    STUDY_OVERVIEW__LATEST_AVAILABLE: "Latest available schema version",
    STUDY_OVERVIEW__NAME: "Name",
    STUDY_OVERVIEW__NOT_AVAILABLE: "Not available",
    STUDY_OVERVIEW__NO_DATA: "No data available",
    STUDY_OVERVIEW__SCHEMA_NAME: "Schema name",
    STUDY_OVERVIEW__SCHEMA_VERSION: "Schema version",
    STUDY_OVERVIEW__STUDIES: "Studies",
    STUDY_OVERVIEW__TYPE: "Type",
    STUDY_OVERVIEW__UNTITLED: "Untitled",
    STUDY_OVERVIEW__UPDATED_AT: "Updated at",
    STUDY_OVERVIEW__UPDATE_DATASET_METADATA: "Update dataset metadata",
    STUDY_OVERVIEW__UPLOAD_STRATEGUS_ANALYSIS_SPEC: "Analysis specification (JSON)",
    STUDY_OVERVIEW__UPLOAD_STRATEGUS_ANALYSIS_SPEC_HINT: "Paste the JSON analysis specification for this study",
    STUDY_OVERVIEW__UPLOAD_STRATEGUS_CANCEL: "Cancel",
    STUDY_OVERVIEW__UPLOAD_STRATEGUS_CHOOSE_DATASET: "Choose dataset",
    STUDY_OVERVIEW__UPLOAD_STRATEGUS_ERROR_DATASET: "Please select a dataset",
    STUDY_OVERVIEW__UPLOAD_STRATEGUS_ERROR_DATASET_NOT_FOUND: "Selected dataset not found",
    STUDY_OVERVIEW__UPLOAD_STRATEGUS_ERROR_FILE: "Please select a file",
    STUDY_OVERVIEW__UPLOAD_STRATEGUS_ERROR_JSON:
      "Invalid JSON in analysis specification. Please paste valid JSON without escape characters.",
    STUDY_OVERVIEW__UPLOAD_STRATEGUS_ERROR_SIZE: "File size exceeds maximum allowed size of 500MB",
    STUDY_OVERVIEW__UPLOAD_STRATEGUS_ERROR_SPEC: "Analysis specification is required",
    STUDY_OVERVIEW__UPLOAD_STRATEGUS_ERROR_STUDY: "Study information is missing",
    STUDY_OVERVIEW__UPLOAD_STRATEGUS_ERROR_UPLOAD: "Upload failed",
    STUDY_OVERVIEW__UPLOAD_STRATEGUS_ERROR_ZIP_ONLY: "Only .zip files are allowed",
    STUDY_OVERVIEW__UPLOAD_STRATEGUS_RESULTS_TITLE: "Upload Strategus results - {0}",
    STUDY_OVERVIEW__UPLOAD_STRATEGUS_SELECT_DATASET: "Select dataset",
    STUDY_OVERVIEW__UPLOAD_STRATEGUS_SELECT_ZIP: "Select zip file (max 500MB)",
    STUDY_OVERVIEW__UPLOAD_STRATEGUS_SUCCESS: "File uploaded successfully! Flow run ID: {0}",
    STUDY_OVERVIEW__UPLOAD_STRATEGUS_UPLOAD: "Upload & process",
    STUDY_OVERVIEW__UPLOAD_STRATEGUS_UPLOADING: "Uploading...",
    STUDY_PAGE__CHOOSE_DATASET: "Choose a dataset",
    STUDY_PAGE__ERROR_LOADING_DATASETS: "Error loading datasets: {0}",
    STUDY_PAGE__NO_STUDIES_FOUND: "No studies found in repository",
    STUDY_PAGE__NO_STUDIES_REPOSITORY_ERROR: "No studies available due to repository error",
    STUDY_PAGE__REPOSITORY_SERVICE_ISSUE: "Repository service issue: {0}",
    STUDY_PAGE__SELECT_DATASET: "Select a dataset:",
    STUDY_PAGE__STUDY_LIST: "Study list",
    STUDY_PAGE__TAB_LOCAL_STUDIES: "Local Studies",
    STUDY_PAGE__TAB_NETWORK_STUDIES: "Network Studies",
    STUDY_TEMPLATE_DIALOG__CANCEL: "Cancel",
    STUDY_TEMPLATE_DIALOG__SAVE: "Save",
    STUDY_TEMPLATE_DIALOG__SAVE_ERROR: "Failed to update code for {0}",
    STUDY_TEMPLATE_DIALOG__SAVE_SUCCESS: "Code saved successfully",
    STUDY_TEMPLATE_DIALOG__TITLE: "Edit Strategus result viewer code for {0}",
    SUPER_ADMIN_PAGE__TITLE: "[Built-in] Super admin plugin page",
    SYSTEM_ADMIN_PAGE__GET_JWT_TOKEN: "Get JWT token",
    SYSTEM_ADMIN_PAGE__HELLO: "Hello {0}",
    SYSTEM_ADMIN_PAGE__SIDE_NAV: "Side navigation",
    SYSTEM_ADMIN_PAGE__SUBTITLE: "Sub header",
    SYSTEM_ADMIN_PAGE__TITLE: "[Built-in] System admin plugin page",
    TAG_TABLE__ADD_TAG: "Add tag",
    TAG_TABLE__DELETE: "Delete",
    TAG_TABLE__LOADER: "Loading tag configs",
    TAG_TABLE__TAG: "Tag",
    TERMINOLOGY_DETAIL__CONCEPT_ID: "Concept ID",
    TERMINOLOGY_DETAIL__DETAILS: "Details",
    TERMINOLOGY_DETAIL__ERROR: "An error has occurred",
    TERMINOLOGY_DETAIL__ERROR_DESCRIPTION: "Please try again.",
    TERMINOLOGY_DETAIL__HIERARCHY: "Hierarchy",
    TERMINOLOGY_DETAIL__RELATED_CONCEPTS: "Related concepts",
    TERMINOLOGY_DETAIL__RELATES_TO: "Relates to",
    TERMINOLOGY_DETAIL__RELATIONSHIP: "Relationship",
    TERMINOLOGY_DETAIL__VOCABULARY: "Vocabulary",
    TERMINOLOGY_LIST__: "Please try again.",
    TERMINOLOGY_LIST__CLASS: "Class",
    TERMINOLOGY_LIST__CODE: "Code",
    TERMINOLOGY_LIST__CONCEPT: "Concept",
    TERMINOLOGY_LIST__DESCENDANTS: "Descendants",
    TERMINOLOGY_LIST__DESCENDANT_PERSON_COUNT: "DPC",
    TERMINOLOGY_LIST__DESCENDANT_RECORD_COUNT: "DRC",
    TERMINOLOGY_LIST__DOMAIN: "Domain",
    TERMINOLOGY_LIST__ERROR: "An error has occurred",
    TERMINOLOGY_LIST__ERROR_DESCRIPTION: "Please try again.",
    TERMINOLOGY_LIST__EXCLUDE: "Exclude",
    TERMINOLOGY_LIST__ID: "ID",
    TERMINOLOGY_LIST__MAPPED: "Mapped",
    TERMINOLOGY_LIST__NAME: "Name",
    TERMINOLOGY_LIST__PERSON_COUNT: "PC",
    TERMINOLOGY_LIST__RECORD_COUNT: "RC",
    TERMINOLOGY_LIST__SCORE: "Score",
    TERMINOLOGY_LIST__VALIDITY: "Validity",
    TERMINOLOGY_LIST__VOCABULARY: "Vocabulary",
    TERMINOLOGY__CLOSE: "Close",
    TERMINOLOGY__CONCEPTS: "Concepts",
    TERMINOLOGY__CONCEPT_SETS: "Concept sets",
    TERMINOLOGY__CONCEPT_SET_NAME: "Concept set name",
    TERMINOLOGY__CONCEPT_SET_NAME_USED_ERROR: "Concept set name {0} already exists. Please enter another name.",
    TERMINOLOGY__CREATE: "Create",
    TERMINOLOGY__CREATING: "creating",
    TERMINOLOGY__ERROR: "Error {0} concept set.",
    TERMINOLOGY__MISSING_USER_ID: "Missing user ID",
    TERMINOLOGY__NAME: "Name",
    TERMINOLOGY__RELATED_CONCEPTS: "Related concepts",
    TERMINOLOGY__SEARCH: "Search",
    TERMINOLOGY__SELECTED_CONCEPTS: "Selected concepts",
    TERMINOLOGY__SELECT_CONCEPTS: "Select concepts",
    TERMINOLOGY__SHARED: "Shared",
    TERMINOLOGY__UPDATE: "Update",
    TERMINOLOGY__UPDATING: "updating",
    TERMS_OF_USE__TITLE: "Terms of use",
    TEST_KEY: "default",
    TREE_MAP_CHART_TABLE__LABEL_TABLE: "Table",
    TREE_MAP_CHART_TABLE__LABEL_TREEMAP: "Treemap",
    TREE_MAP_CHART_TABLE__NO_DATA: "Results not available",
    TREE_MAP_CHART__CHART_LEGEND: "Box Size: Prevalence",
    TREE_MAP_CHART__NUMBER_OF_PEOPLE: "Number of persons",
    TREE_MAP_CHART__PREVALENCE: "Prevalence",
    TREE_MAP_CHART__RECORDS_PER_PERSON: "Average records per person",
    TREE_MAP_TABLE__HEADER_CONCEPT_ID: "Concept ID",
    TREE_MAP_TABLE__HEADER_CONCEPT_PATH: "Name",
    TREE_MAP_TABLE__HEADER_NUM_PERSONS: "Person count",
    TREE_MAP_TABLE__HEADER_PERCENT_PERSONS: "Prevalence",
    TREE_MAP_TABLE__HEADER_RECORDS_PER_PERSON: "Length of era",
    TREX_PLUGINS__DESCRIPTION: "Description",
    TREX_PLUGINS__INSTALLING: "Installing...",
    TREX_PLUGINS__INSTALL_FAILED_ERROR_DESCRIPTION:
      "Please try again. To report the error, please send an email to your administrator.",
    TREX_PLUGINS__INSTALL_FAILED_ERROR_MESSAGE: "Installation failed",
    TREX_PLUGINS__INSTALL_NEW_PLUGIN: "Install new plugin",
    TREX_PLUGINS__INSTALL_SUCCESS: "Installation successful",
    TREX_PLUGINS__LATEST_VERSION: "Latest version",
    TREX_PLUGINS__NAME: "Name",
    TREX_PLUGINS__NO_DATA: "No plugins",
    TREX_PLUGINS__STATUS: "Status",
    TREX_PLUGINS__TITLE: "Plugins",
    TREX_PLUGINS__UNINSTALL: "Uninstall",
    TREX_PLUGINS__UPDATE_FAILED_ERROR_DESCRIPTION:
      "Please try again. To report the error, please send an email to your administrator.",
    TREX_PLUGINS__UPDATE_FAILED_ERROR_MESSAGE: "Update failed",
    TREX_PLUGINS__UPDATE_SUCCESS: "Update successful",
    TREX_PLUGINS__URL: "URL",
    TREX_PLUGINS__VERSION: "Version",
    TREX_PLUGIN_INSTALL_DIALOG__CANCEL: "Cancel",
    TREX_PLUGIN_INSTALL_DIALOG__ERROR: "Error while installing plugin",
    TREX_PLUGIN_INSTALL_DIALOG__ERROR_DESCRIPTION:
      "Please try again. To report the error, please send an email to your administrator.",
    TREX_PLUGIN_INSTALL_DIALOG__INSTALL: "Install",
    TREX_PLUGIN_INSTALL_DIALOG__NAME: "Name",
    TREX_PLUGIN_INSTALL_DIALOG__TITLE: "Install new plugin",
    TREX_PLUGIN_UNINSTALL_DIALOG__CANCEL: "Cancel",
    TREX_PLUGIN_UNINSTALL_DIALOG__CONFIRM_1: "Are you sure you want to uninstall the following",
    TREX_PLUGIN_UNINSTALL_DIALOG__CONFIRM_2: "plugin",
    TREX_PLUGIN_UNINSTALL_DIALOG__CONFIRM_3: "Type the plugin name to confirm.",
    TREX_PLUGIN_UNINSTALL_DIALOG__CONFIRM_UNINSTALL: "Confirm uninstall",
    TREX_PLUGIN_UNINSTALL_DIALOG__ENTER_EXACT_FLOW_NAME: "Enter the exact plugin name",
    TREX_PLUGIN_UNINSTALL_DIALOG__ENTER_FLOW_NAME: "Enter plugin name",
    TREX_PLUGIN_UNINSTALL_DIALOG__ERROR: "Plugin {0} failed to uninstall",
    TREX_PLUGIN_UNINSTALL_DIALOG__SUCCESS:
      "Plugin {0} successfully uninstalled. Changes will be reflected upon system restart.",
    TREX_PLUGIN_UNINSTALL_DIALOG__UNINSTALL: "Uninstall plugin",
    TRIGGER_PLUGIN_UPLOAD_DIALOG__DESCRIPTION:
      "Please try again. To report the error, please send an email to your administrator.",
    TRIGGER_PLUGIN_UPLOAD_DIALOG__TITLE: "Install default plugins",
    UI_PLUGIN_ANALYSIS: "Analysis",
    UI_PLUGIN_CDM_CONFIG: "CDM configuration",
    UI_PLUGIN_COHORTS: "Cohorts",
    UI_PLUGIN_CONCEPTS: "Concepts",
    UI_PLUGIN_DATABASES: "Databases",
    UI_PLUGIN_DATASETS: "Datasets",
    UI_PLUGIN_DEMO_SETUP: "Demo setup",
    UI_PLUGIN_ETL: "ETL",
    UI_PLUGIN_FEATURE_FLAGS: "Feature flags",
    UI_PLUGIN_GIT_CONFIG: "Git configuration",
    UI_PLUGIN_HYBRID_SEARCH: "Hybrid search",
    UI_PLUGIN_JOBS: "Jobs",
    UI_PLUGIN_KAPLAN_MEIER: "Kaplan-Meier",
    UI_PLUGIN_LOGS: "Logs",
    UI_PLUGIN_METADATA: "Metadata",
    UI_PLUGIN_NOTEBOOKS: "Notebooks",
    UI_PLUGIN_WEBR_NOTEBOOKS: "Notebooks",
    UI_PLUGIN_OVERVIEW_DESCRIPTION: "Platform content & legal texts",
    UI_PLUGIN_PATIENT_ANALYTICS_CONFIG: "Cohort builder config",
    UI_PLUGIN_PLUGINS: "Plugins",
    UI_PLUGIN_SETUP: "Setup",
    UI_PLUGIN_SETUP_CDM_DESCRIPTION: "Configure CDM",
    UI_PLUGIN_SETUP_DB_DESCRIPTION: "Database connection and credentials",
    UI_PLUGIN_SETUP_DEMO_DESCRIPTION: "Setting up demo dataset",
    UI_PLUGIN_SETUP_FEATURE_FLAGS_DESCRIPTION: "Enable / disable feature",
    UI_PLUGIN_SETUP_GIT_DESCRIPTION: "Allow user to configure the git information",
    UI_PLUGIN_SETUP_HYBRID_SEARCH_DESCRIPTION: "Configure hybrid search for concepts",
    UI_PLUGIN_SETUP_METADATA_DESCRIPTION: "Configure dataset metadata and tags",
    UI_PLUGIN_SETUP_OVERVIEW_DESCRIPTION: "Set image, descriptions, and legal texts",
    UI_PLUGIN_SETUP_PATIENT_ANALYTICS_DESCRIPTION: "Configure cohort builder",
    UI_PLUGIN_SETUP_PLUGINS_DESCRIPTION: "Manage plugins",
    UI_PLUGIN_SHINY_LIVE: "Dashboard",
    UI_PLUGIN_SHINY_LIVE__LOADING: "Loading available dashboards...",
    UI_PLUGIN_SHINY_LIVE__LOADING_DOTS: "Loading...",
    UI_PLUGIN_SHINY_LIVE__NO_DASHBOARDS: "No dashboards available for this dataset",
    UI_PLUGIN_SHINY_LIVE__NO_DASHBOARD_FOR_SELECTION: "No dashboard available for this selection.",
    UI_PLUGIN_SHINY_LIVE__SELECT_DASHBOARD: "Select dashboard",
    UI_PLUGIN_SHINY_LIVE__UNAUTHORIZED:
      "You don't have permission to view strategus analysis results. Please contact your administrator.",
    UI_PLUGIN_SHINY_LIVE__VIEWER_NOT_RUNNING: "The result viewer is not running. Start it from the admin portal.",
    UI_PLUGIN_STUDIES: "Studies",
    UI_PLUGIN_USERS: "Users",
    UI_PLUGIN_WIZARDS: "Wizards",
    UPDATE_SCHEMA_DIALOG__CANCEL: "Cancel",
    UPDATE_SCHEMA_DIALOG__CONFIRM: "Are you sure you want to update the schema of this dataset:",
    UPDATE_SCHEMA_DIALOG__ERROR: "Schema for dataset {0} failed to update",
    UPDATE_SCHEMA_DIALOG__UPDATE: "Yes, update",
    UPDATE_SCHEMA_DIALOG__UPDATE_SCHEMA: "Update schema",
    UPDATE_STUDY_DIALOG__CANCEL: "Cancel",
    UPDATE_STUDY_DIALOG__CODE_REQUIREMENT: "Should only contain letters, numbers, and underscores",
    UPDATE_STUDY_DIALOG__DATASET_INFO_CONFIG: "Dataset info configuration",
    UPDATE_STUDY_DIALOG__DATASET_NAME: "Dataset name - Displayed on buttons and headers",
    UPDATE_STUDY_DIALOG__DATASET_SUMMARY: "Dataset summary",
    UPDATE_STUDY_DIALOG__DATASET_VISIBILITY: "Dataset visibility",
    UPDATE_STUDY_DIALOG__DESCRIPTION: "Description",
    UPDATE_STUDY_DIALOG__HIDDEN: "Hidden (only researchers and the tenant admin)",
    UPDATE_STUDY_DIALOG__PA_CONFIG: "PA config",
    UPDATE_STUDY_DIALOG__PRIVATE: "Private (only users from the tenant)",
    UPDATE_STUDY_DIALOG__PUBLIC: "Public",
    UPDATE_STUDY_DIALOG__REQUEST: "Show request access button",
    UPDATE_STUDY_DIALOG__REQUIRED: "This is required",
    UPDATE_STUDY_DIALOG__RESULT_SCHEMA_NAME: "Result schema name",
    UPDATE_STUDY_DIALOG__SAVE: "Save",
    UPDATE_STUDY_DIALOG__SUCCESS: "Dataset updated successfully",
    UPDATE_STUDY_DIALOG__TAGS: "Tags",
    UPDATE_STUDY_DIALOG__TOKEN_CODE: "Token dataset code",
    UPDATE_STUDY_DIALOG__TYPE: "Type",
    UPDATE_STUDY_DIALOG__UPDATE_DATASET: "Update dataset",
    UPDATE_STUDY_DIALOG__VALID_TOKEN_CODE: "Please enter a valid Token dataset code",
    UPDATE_STUDY_DIALOG__VOCAB_SCHEMA_NAME: "Vocab schema name",
    TRANSFORM_TO_WEBAPI__BODY:
      "This merges the cache dataset into the source row and deletes the cache row. Researcher roles on the cache row will be orphaned and must be re-granted on the source after migration. Continue?",
    TRANSFORM_TO_WEBAPI__TITLE: "Convert dataset to WebAPI-managed",
    USER_OVERVIEW__ACTIVATE_ERROR: "Failed to activate user. Please try again.",
    USER_OVERVIEW__ACTIVATE_SUCCESS: "User activated successfully",
    USER_OVERVIEW__ADD_USER: "Add user",
    USER_OVERVIEW__DEACTIVATE_ERROR: "Failed to deactivate user. Please try again.",
    USER_OVERVIEW__DEACTIVATE_SUCCESS: "User deactivated successfully",
    USER_OVERVIEW__DELETE: "Delete",
    USER_OVERVIEW__EDIT: "Edit",
    USER_OVERVIEW__EDIT_ROLE_SUCCESS:
      "User {0} has been granted new roles. Notify the user they must sign in again to apply them",
    USER_OVERVIEW__INACTIVE: "Inactive",
    USER_OVERVIEW__NO_DATA: "No data available",
    USER_OVERVIEW__ROLE: "Role",
    USER_OVERVIEW__USERNAME: "Username",
    USER_OVERVIEW__USERS: "Users",
  },
};

function getKeyMap<T extends object>(obj: T) {
  const result = {} as Record<keyof T, keyof T>;
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key as keyof T] = key as keyof T;
    }
  }
  return result as { [K in keyof T]: K };
}

// Exposing the default key map so that getText('MRI_PA_FILTERCARD_SELECTION_NONE')
// can be getText(i18nKeys.MRI_PA_FILTERCARD_SELECTION_NONE)
// to prevent typos with the values
export const i18nKeys = getKeyMap(i18nDefault.default);

export interface TranslationState {
  locale: string;
  translations: { [key: string]: typeof i18nDefault.default };
}
